<div class="row">
    <div class="col-12">
       <ngx-loading [show]="loadingIndicator"></ngx-loading>
    </div>

   <div class="col-md-10" *ngIf="!loadingIndicator">
       <div class="row mb-3">
           <div class="col-md-12">
               <div class="card border-0 box-shadow">
                   <div class="card-header transparent border-0 text-muted mb-2">
                       <div class="row">
                           <div class="col d-flex flex-wrap justify-content-between align-items-center">
                                <div>
                                    <h5 class="d-inline align-middle mr-2"> Overview of {{runData?.control_no}}</h5>
                                    <p *ngIf="runData?.run_status_id == '1'" class="d-inline align-text-bottom badge badge-pill badge-secondary">Pending</p>
                                    <p *ngIf="runData?.run_status_id == '2'" class="d-inline align-text-bottom badge badge-pill badge-light">Dispatched</p>
                                    <p *ngIf="runData?.run_status_id == '3'" class="d-inline align-text-bottom badge badge-pill badge-primary">Processing</p>
                                    <p *ngIf="runData?.run_status_id == '4'" class="d-inline align-text-bottom badge badge-pill badge-success">Completed</p>
                                    <p *ngIf="runData?.run_status_id == '5'" class="d-inline align-text-bottom badge badge-pill badge-danger">Cancelled</p>
                                    <p *ngIf="runData?.run_status_id == '6'" class="d-inline align-text-bottom badge badge-pill badge-warning">Withdrawn</p>
                                    <p *ngIf="runData?.run_status_id == '7'" class="d-inline align-text-bottom badge badge-pill badge-info">Subcontracted</p>
                                    <p *ngIf="runData?.run_status_id == '8'" class="d-inline align-text-bottom badge badge-pill badge-info">Saved as Draft</p>
                                    <span class=" pl-1"><p *ngIf="runData?.has_tba == 1" class="d-inline align-text-bottom badge badge-pill badge-danger">TBA</p></span>
                                    <a *ngIf="![4, 5, 6, 7].includes(runData.run_status_id)" title="Edit" [routerLink]="['/dispatch/editor']" [queryParams]="{ id: runData.id }"><i class="fa fa-fw fa-pencil"></i></a>
                                </div>
                              
                                <button *ngIf="![4, 5, 6, 7].includes(runData.run_status_id)" class="btn btn-outline-secondary btn-rounded pull-right" (click)="openModalEditJobs()" [disabled]="jobEditDisableBtn">
                                    <i class="fa fa-spinner fa-spin" *ngIf="jobEditDisableBtn" aria-hidden="true"></i>
                                    {{(jobEditDisableBtn)?'Opening Editor...' : 'Update Job'}} 
                               </button>
                           </div>
                       </div>
                   </div>

                   <div class="card-body py-2">
                       <div class="row">
                           <div class="col-md-2 col-sm-12 mb-2">
                               <small class="d-block text-muted">JOB TYPE</small>
                               <ng-container *ngFor="let type of run_types">
                                   <ng-container *ngIf="type.id == runData?.run_type_id">
                                       <h6 class="d-inline mr-1">{{ type.label }}</h6>
                                       <span style="cursor: pointer;" (click)="viewChangeover(runData.changeover_run_id)" *ngIf="runData.changeover_run_id != null" 
                                           class="badge badge-pill badge-warning" data-toggle="tooltip" title="Changeover with {{runData.changeover_control_no}}" placement="right">Changeover</span>                                            
                                   </ng-container>
                               </ng-container>
                           </div>

                           <div class="col-md-3 col-sm-12 mb-2">
                               <small class="d-block text-muted">SERVICE TYPE</small>
                               <ng-container *ngFor="let service of service_types">
                                   <ng-container *ngIf="service.id == runData?.service_type_id">
                                       <h6>{{ service.name }}</h6>
                                   </ng-container>
                                   <ng-container *ngIf="service.id == null || service.id == ''">
                                       <h6>-</h6>
                                   </ng-container>
                               </ng-container>
                           </div>

                           <div class="col-md-3 col-sm-12 mb-2">
                               <small class="d-block text-muted">EST. TRIP SCHEDULE</small>
                               <h6>
                                   <span *ngIf="runData?.departure_date && runData?.departure_time;else departureEmpty">
                                       {{ runData?.departure_date | date:'d MMM y'}}, {{runData?.departure_time | date:'shortTime'}} &ndash;  
                                   </span>
                                   <ng-template #departureEmpty>
                                       <span>TBA &ndash; </span>
                                   </ng-template>
                                   
                                   <span *ngIf="runData?.arrival_date && runData?.arrival_time;else arrivalEmpty">
                                       {{ runData?.arrival_date | date:'d MMM y'}}, {{runData?.arrival_time | date:'shortTime'}}
                                   </span>
                                   <ng-template #arrivalEmpty>
                                       <span>TBA</span>
                                   </ng-template>
                               </h6>
                           </div>

                           <div class="col-md-2 col-sm-12 mb-2">
                               <small class="d-block text-muted">EST. DISTANCE</small>
                               <h6>{{runData?.total_klms | number}} km</h6>
                           </div>

                           <div class="col-md-2 mb-2">
                               <small class="d-block text-muted">EST. TRIP TIME</small>
                               <h6> {{runData?.drv_Hours}} </h6>
                           </div>
                       </div>
                       
                       <div class="row">
                           <div class="col-md-2 col-sm-12 mb-2">
                               <small class="d-block text-muted">DRIVER<span *ngIf="runData?.driver.length > 1">S</span></small>
                               <ng-container *ngFor="let driver of runData?.driver; let i = index">
                                   <div class="row">
                                       <div class="col">
                                            <a href="javascript:void(0);" (click)="viewDriver(driver.driver_id)" title="View details of {{driver?.first_name}} {{driver?.last_name}}">
                                                <h6> {{driver?.first_name}} {{driver?.last_name}}</h6>
                                            </a>   
                                       </div>
                                   </div>
                               </ng-container><br>
                               <small class="d-block text-muted">TRUCK</small>
                               <ng-container *ngFor="let fleet of runData?.equipment;">
                                    <ng-container *ngIf="fleet.is_truck == 1">
                                        <a href="javascript:void(0);" (click)="viewFleet(fleet.equipment_id)" title="View details of {{fleet.rego}}" *ngIf="fleet.deleted_date == null">
                                            <h6>{{fleet.rego}}</h6>
                                        </a>
                                        <h6 *ngIf="fleet.deleted_date != null">{{fleet.rego}}</h6>
                                        <p class="badge badge-danger p-1" *ngIf="fleet.deleted_date != null">Decommissioned</p>
                                    </ng-container>
                               </ng-container>
                           </div>

                           <div class="col-md-3 col-sm-12 mb-2">
                               <small class="d-block text-muted">TRAILERS</small>
                               <!-- sorts trailers to which is active (on changeover) -->
                               <ng-container *ngFor="let fleet of runData?.equipment;">
                                    <ng-container *ngIf="fleet.is_truck == 0">
                                        <a style="font-size:14px; font-weight:500;"href="javascript:void(0);" (click)="viewFleet(fleet.equipment_id)" title="View details of {{fleet.rego}}" *ngIf="fleet.deleted_date == null">
                                            {{fleet.rego}}&nbsp;
                                        </a>
                                        <h6 *ngIf="fleet.deleted_date != null">{{fleet.rego}}</h6>
                                        <p class="badge badge-danger p-1" *ngIf="fleet.deleted_date != null">Decommissioned</p>
                                    </ng-container>
                               </ng-container>
                           </div>

                           <div class="col-md-3 col-sm-12 mb-2">
                               <small class="d-block text-muted">ROUTE</small>
                               <span *ngIf="runData?.run_type_id != 1">
                                   <ng-container *ngFor="let route of routes;">
                                       <span *ngIf="route.id == runData?.run_routes_id">
                                           <h6>{{route.start_name}} ({{route.start_abbrev}})&nbsp;-
                                               <span *ngIf="route.changeover_state_id != null">&nbsp;{{route.changeover_name}} ({{route.changeover_abbrev}})&nbsp;-</span>
                                               &nbsp;{{route.end_name}} ({{route.end_abbrev}})
                                           </h6>
                                           <!-- <h6>{{route.klms| number}} km</h6> -->
                                       </span>
                                   </ng-container>
                               </span>
                 
                               


                           </div>

                           <div class="col-md-2 col-sm-12 mb-2">
                               <small class="d-block text-muted">DISPATCHER</small>
                               <h6>{{runData?.createdby_name}}<br>{{ runData?.created_at | date:'d MMM y, h:mm:ss a'}}</h6>
                               <!-- <small class="d-block text-muted">DISPATCHED ON</small> -->
                               <h6></h6>
                           </div>

                           <div class="col-md-2 col-sm-12 mb-2">
                               <small class="d-block text-muted">EXCLUDED WORK DAYS</small>
                               <h6>
                                   <ng-container *ngIf="runData.is_excluded_saturday == 1 || runData.is_excluded_sunday == 1 || runData.is_excluded_holiday_no == 1; else noWorkExcluded">
                                       <span *ngIf="runData.is_excluded_saturday == 1">Saturdays</span>
                                        <span *ngIf="runData.is_excluded_saturday == 1 && runData.is_excluded_sunday == 1 && runData.is_excluded_holiday_no == 0">&nbsp;and&nbsp;</span>
                                        <span *ngIf="runData.is_excluded_saturday == 1 && runData.is_excluded_sunday == 1 && runData.is_excluded_holiday_no == 1">,&nbsp;</span>
                                        <span *ngIf="runData.is_excluded_sunday == 1">Sundays</span>
                                        <span *ngIf="runData.is_excluded_holiday_no == 1">&nbsp;and
                                            {{runData.excluded_holiday_dates}} (Holidays)
                                        </span>
                                    </ng-container>
                                    <ng-template #noWorkExcluded>
                                        <span>All work days included</span>
                                    </ng-template>
                               </h6>                                
                           </div>
                       </div>
                   </div>
               </div>
           </div>
       </div>


       <div class="row">
           <div class="col-md-3">
               <div class="card border-0 box-shadow mb-3">
                   <div class="card-header transparent border-0 text-muted pb-0">
                       <h5>Compliance Checklist  <input type="checkbox" style=" vertical-align: middle;float: right;margin: 5px 0px;" id="isChecklist" [(ngModel)]="isChecklist" (change)="onChangeChecklist()"></h5> 
                       <div class="progress my-4">
                           <div class="progress-bar progress-bar-striped progress-bar-animated"  [ngClass]="(compliancePercentage<1)?'bg-danger':'bg-success'" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" [ngStyle]="applyComplianceBarStyles()">{{compliancePercentage | number : '1.0-2'}}%
                           </div>
                       </div>
                   </div>

                   <div class="card-body pt-0 mb-3">     
                       <div class="custom-control custom-checkbox checkbox-circle my-3">
                           <input type="checkbox" class="custom-control-input checkbox-success" id="isDriverFitnessChecked" [(ngModel)]="isDriverFitnessChecked" disabled="disabled" *ngIf="runData?.is_checklist == 0">
                           <input type="checkbox" class="custom-control-input checkbox-success" id="isDriverFitnessChecked" [(ngModel)]="isDriverFitnessChecked" (change)="onChangeDriverFitnessChecked()"  *ngIf="runData?.is_checklist > 0">
                           <label class="custom-control-label" for="isDriverFitnessChecked">Driver Fitness for Duty Checked</label>
                       </div>   

                       <div class="custom-control custom-checkbox checkbox-circle my-3">
                           <input type="checkbox"  class="custom-control-input checkbox-success" id="isFleetChecked" [(ngModel)]="isFleetChecked" disabled="disabled" *ngIf="runData?.is_checklist == 0">
                           <input type="checkbox" class="custom-control-input checkbox-success" id="isFleetChecked" [(ngModel)]="isFleetChecked" (change)="onChangeFleetChecked()"  *ngIf="runData?.is_checklist > 0">

                           <label class="custom-control-label" for="isFleetChecked">Fleet Checked</label>
                       </div>

                       <div class="custom-control custom-checkbox checkbox-circle my-3" *ngIf="runData.run_type_id != 1 && runData.run_type_id != 3 && hasPickupActivity">
                           <input type="checkbox"  class="custom-control-input checkbox-success" id="isLoadRestraintChecked" [(ngModel)]="isLoadRestraintChecked" (change)="onChangeLoadRestraintChecked()">
                            <label class="custom-control-label" for="isLoadRestraintChecked">
                                Load Restraint Submitted
                            </label>
                       </div>
                       
                       <div class="custom-control custom-checkbox checkbox-circle my-3" *ngIf="runData.run_type_id != 1 && runData.run_type_id != 6">
                            <input type="checkbox" class="custom-control-input checkbox-success" id="isMassWeightsChecked" [(ngModel)]="isMassWeightsChecked" disabled="disabled"  *ngIf="runData?.is_checklist == 0">
                            <input type="checkbox" class="custom-control-input checkbox-success" id="isMassWeightsChecked" [(ngModel)]="isMassWeightsChecked" (change)="onChangeMassWeightsChecked()" *ngIf="runData?.is_checklist > 0">
                            <label class="custom-control-label" for="isMassWeightsChecked">
                                Mass Weights Checked
                            </label>
                        </div>

                       <div class="custom-control custom-checkbox checkbox-circle my-3" *ngIf="runData.run_type_id != 1 && runData.run_type_id != 6">
                           <input type="checkbox"  class="custom-control-input checkbox-success" id="isWorkDiarySubmitted" [(ngModel)]="isWorkDiarySubmitted" (change)="onChangeWorkDiarySubmitted()">
                           <label class="custom-control-label" for="isWorkDiarySubmitted">
                                Work Diary Submitted
                            </label>
                       </div>

                       <div class="custom-control custom-checkbox checkbox-circle my-3">
                           <input type="checkbox"  class="custom-control-input checkbox-success" id="isLocationChecked" [(ngModel)]="isLocationChecked" (change)="onChangeLocationChecked()">
                           <label class="custom-control-label" for="isLocationChecked" >Location Checked on Fuel Docket/GPS</label>
                       </div>

                       <div class="custom-control custom-checkbox checkbox-circle my-3" *ngIf="runData.run_type_id != 1 && runData.run_type_id != 6">
                           <input type="checkbox"  class="custom-control-input checkbox-success" id="isFatigueRequirementsSubmitted" [(ngModel)]="isFatigueRequirementsSubmitted" (change)="onChangeFatigueRequirementsSubmitted()">
                           <label class="custom-control-label" for="isFatigueRequirementsSubmitted">
                                Fatigue Requirements Submitted
                            </label>
                       </div>
                   </div>

               </div>

               <div widget class="card border-0 box-shadow mb-3">
                   <div class="card-header transparent border-0 text-muted">
                       <h5>Documentation</h5>
                       <div align="right">
                           <button type="button" class="btn btn-outline-info btn-sm mb-1 mr-1" aria-expanded="false" (click)="openModal(doc)"><span>Generate Documents</span></button>
                       </div>
                   </div>  

                   <div class="card-body pt-0">
                       <div class="clearfix">
                           <ul class="nav nav-tabs top">
                               <li class="nav-item">
                                   <a class="nav-link active" data-toggle="tab" href="#compliance"><small>Compliance</small></a>
                               </li>
                               <li class="nav-item">
                                   <a class="nav-link" data-toggle="tab" href="#documents"><small>Other Documents</small></a>
                               </li>
                               <li class="nav-item">
                                   <a class="nav-link" data-toggle="tab" href="#uploads"><small>Uploads</small></a>
                               </li>
                           </ul>
                       </div>
                       <div class="tab-content top">
                           <!-- COMPLIANCE TAB -->
                           <div class="tab-pane active" id="compliance">
                               <div class="mt-0 pt-1">
                                   <small>
                                       <ul class="list-group">
                                           <b>Driver Test:</b>
                                           <ng-container *ngFor="let test of d_test">
                                               <a href="{{fileStoragePath}}/compliance/{{test.file}}" target="_blank">{{test.file}}</a>
                                           </ng-container>
                                           <span *ngIf="d_test.length == 0"><i>No File Available.</i></span>
                                           <br>
                                           <b>Truck Checks:</b>
                                           <ng-container *ngFor="let test of trk_test">
                                               <a href="{{fileStoragePath}}/compliance/{{test.file}}" target="_blank">{{test.file}}</a>
                                           </ng-container>
                                           <span *ngIf="trk_test.length == 0"><i>No File Available.</i></span>
                                           <br>
                                           <b>Trailer Checks:</b>
                                           <ng-container *ngFor="let test of trl_test">
                                               <a href="{{fileStoragePath}}/compliance/{{test.file}}" target="_blank">{{test.file}}</a>
                                           </ng-container>
                                           <span *ngIf="trl_test.length == 0"><i>No File Available.</i></span>
                                           <br>
                                           <b>Safe Driving Plan:</b>
                                           <div class="row m-0">
                                               <a *ngIf="runData?.sdp_file != null" href="{{fileStoragePath}}/sdp/{{runData?.sdp_file}}" target="_blank">{{ runData?.sdp_file}}</a>
                                               <span *ngIf="runData?.sdp_file == null || runData?.sdp_file == ''"><i>No File Available.</i></span>
                                               &nbsp;&nbsp;<i *ngIf="(runData?.run_type_id != 1 && runData?.run_type_id != 6 && (runData?.total_klms > 500 || is_multiple_connotes))" class="btn-link fa fa-refresh fa-spin" style="font-size:15px"
                                                   data-toggle="tooltip" title="Generate new SDP" aria-hidden="true" (click)="openGenerateSDPModal()"></i>
                                           </div>                                            
                                           <br>
                                           <b>Tripsheet:</b>
                                           <a *ngIf="runData?.tripsheet_file != null" href="{{fileStoragePath}}/tripsheet/{{runData?.tripsheet_file}}"
                                           target="_blank">{{ runData?.tripsheet_file}} </a>
                                           <span *ngIf="runData?.tripsheet_file == null || runData?.tripsheet_file == ''"><i>No File Available.</i></span>
                                           <br>
                                           <b>Manifest:</b>
                                           <a *ngIf="runData?.manifest_file != null" href="{{fileStoragePath}}/manifestfile/{{runData?.manifest_file}}"
                                           target="_blank">{{ runData?.manifest_file}} </a>
                                           <span *ngIf="runData?.manifest_file == null || runData?.manifest_file == ''"><i>No File Available.</i></span>

                                       </ul>
                                   </small>
                               </div>
                           </div>

                           <!-- DOCUMENTS TAB -->
                           <div class="tab-pane " id="documents">
                               <small>
                                   <ul class="list-group">
                                       <b>Connote:</b>
                                       <ng-container *ngFor="let con of connote_files">
                                           <a href="{{fileStoragePath}}/connotes/{{con.file}}" target="_blank">{{con.file}}</a>
                                       </ng-container>
                                       <span *ngIf="connote_files.length == 0"><i>No File Available.</i></span>
                                       <br>
                                       <b>Proof of Pickup and Delivery:</b>
                                       <ng-container *ngFor="let ppd of ppd_files">
                                           <a href="{{fileStoragePath}}/ppd/{{ppd.file}}" target="_blank">{{ppd.file}}</a>
                                       </ng-container>
                                       <span *ngIf="ppd_files.length == 0"><i>No File Available.</i></span>
                                       <br>
                                       <b>Pickup Docket:</b>
                                       <ng-container *ngFor="let p_docket of pickup_docket_file">
                                           <a href="{{fileStoragePath}}/{{p_docket.folder_path}}/{{p_docket.filename}}" target="_blank">{{p_docket.filename}}</a>
                                       </ng-container>
                                       <span *ngIf="pickup_docket_file.length == 0"><i>No File Available.</i></span>
                                       <br>
                                       <ng-container *ngIf="release_docket_file.length != 0">
                                           <b>Release Docket:</b>
                                           <ng-container *ngFor="let r_docket of release_docket_file">
                                               <div class="row m-0">
                                               <a href="{{fileStoragePath}}/{{r_docket.folder_path}}/{{r_docket.filename}}" target="_blank">{{r_docket.filename}}</a>&nbsp;<i class="btn-link fa fa-refresh" style="font-size:13px" 
                                               data-toggle="tooltip" title="Generate New Release Docket" aria-hidden="true" (click)="openModalRelease(r_docket.run_event_id)" ></i></div>
                                           </ng-container>
                                           <span *ngIf="release_docket_file.length == 0"><i>No File Available.</i></span>
                                           <br>
                                       </ng-container>
                                       <ng-container *ngIf="collect_docket_file.length != 0">
                                           <b>Collect Docket:</b>
                                           <ng-container *ngFor="let c_docket of collect_docket_file">
                                               <div class="row m-0">
                                               <a href="{{fileStoragePath}}/{{c_docket.folder_path}}/{{c_docket.filename}}" target="_blank">{{c_docket.filename}}</a>&nbsp;<i class="btn-link fa fa-refresh" style="font-size:13px"
                                               data-toggle="tooltip" title="Generate New Collect Docket" aria-hidden="true" (click)="openModalCollect(c_docket.run_event_id)"></i></div>
                                           </ng-container>
                                           <span *ngIf="release_docket_file.length == 0"><i>No File Available.</i></span>
                                           <br>
                                       </ng-container>
                                       <b>Delivery Docket:</b>
                                       <ng-container *ngFor="let d_docket of delivery_docket_file">
                                           <a href="{{fileStoragePath}}/{{d_docket.folder_path}}/{{d_docket.filename}}" target="_blank">{{d_docket.filename}}</a>
                                       </ng-container>
                                       <span *ngIf="delivery_docket_file.length == 0"><i>No File Available.</i></span>
                                       <br>
                                       <b>Runsheet:</b>
                                       <ng-container *ngFor="let runsheet of runsheet_files">
                                           <div class="row m-0">
                                               <a href="{{fileStoragePath}}/runsheet/{{runsheet.file == null ? runsheet : runsheet.file}}" target="_blank">{{runsheet.file == null ? runsheet : runsheet.file}} </a>&nbsp; <i class="btn-link fa fa-refresh" style="font-size:14px"
                                               data-toggle="tooltip" title="Generate New Runsheet" aria-hidden="true" (click)="openModalRunsheet()"></i>
                                           </div>
                                       </ng-container>
                                       <span *ngIf="runsheet_files.length == 0"><i>No File Available.</i></span>
                                       <br>
                                       <b>Packaging Label:</b>
                                       <ng-container *ngFor="let pl of plabel_files">
                                           <a href="{{fileStoragePath}}/packaging_label/{{pl.file}}" target="_blank">{{pl.file}}</a>
                                       </ng-container>
                                       <span *ngIf="plabel_files.length == 0"><i>No File Available.</i></span>
                                       <br>
                                   </ul>
                               </small>
                           </div>

                           <!-- UPLOADS TAB -->
                           <div class="tab-pane" id="uploads">
                               <div class="mt-0 pt-1">
                                   <small>
                                       <div class="list-group">
                                           <b>Proof of Delivery:</b>
                                           <ng-container *ngFor="let pod of pod_files">
                                               <a href="{{fileStoragePath}}/pod/{{pod.file}}" target="_blank">{{pod.file}}</a>
                                           </ng-container>
                                           <span *ngIf="pod_files.length == 0"><i>No File Available.</i></span>
                                           <br>
                                           <b>Fuels:</b>
                                           <ng-container *ngFor="let fuel of fuels">
                                               <a href="{{fileStoragePath}}/fuel/{{fuel.file}}" target="_blank">{{fuel.file}}</a>
                                           </ng-container>
                                           <span *ngIf="fuels.length == 0"><i>No File Available.</i></span>
                                           <br>
                                           <b>Pickup Docket Images:</b>
                                           <ng-container *ngFor="let p_docket_img of pickup_docket_img">
                                               <a href="{{fileStoragePath}}/{{p_docket_img.folder_path}}/{{p_docket_img.filename}}" target="_blank">{{p_docket_img.filename}}</a>
                                           </ng-container>
                                           <span *ngIf="pickup_docket_img.length == 0"><i>No File Available.</i></span>
                                           <br>
                                           <b>Delivery Docket Images:</b>
                                           <ng-container *ngFor="let d_docket_img of delivery_docket_img">
                                               <a href="{{fileStoragePath}}/{{d_docket_img.folder_path}}/{{d_docket_img.filename}}" target="_blank">{{d_docket_img.filename}}</a>
                                           </ng-container>
                                           <span *ngIf="delivery_docket_img.length == 0"><i>No File Available.</i></span>
                                           <br>
                                           <b>Collect Docket Images:</b>
                                           <ng-container *ngFor="let c_docket_img of runData?.collect_docket_img">
                                               <a href="{{fileStoragePath}}/{{c_docket_img.folder_path}}/{{c_docket_img.filename}}" target="_blank">{{c_docket_img.filename}}</a>
                                           </ng-container>
                                           <span *ngIf="runData?.collect_docket_img.length == 0"><i>No File Available.</i></span>
                                           <br>
                                       </div>
                                   </small>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>
           </div>

           <div class="col-md-5">
            <div widget class="card border-0 box-shadow mb-3">
                <div class="card-header transparent border-0 text-muted">
                    <div class="row">
                        <div class="col-md-9">
                            <h5>Trip Events</h5>
                        </div>
                        <div class="col-md-3 p-0">
                            <a *ngIf="checkDeallocateValidity()" (click)="openDeallocateModal()"><u>Deallocate Connote</u></a>
                        </div>
                    </div>
                    <div class="clearfix">
                        <ul class="nav nav-tabs top">
                            <li class="nav-item">
                                <a class="nav-link active" data-toggle="tab" href="#ta">Actual</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#tb">Planned</a>
                            </li>
                        </ul>
                    </div>
                    <div class="tab-content top">
                        <div class="tab-pane active" id="ta">
                            <div class="mt-0" style="text-align: center;"
                                *ngIf="runData?.actual_activities.length == 0; else ActList">
                                <span *ngIf="runData?.run_status_id == 5"><i>Dispatch Cancelled.</i></span>
                                <span *ngIf="runData?.run_status_id != 5"><i>No ongoing activities.</i></span>
                            </div>
                            <ng-template #ActList>
                                <div class="" *ngFor="let list of runData?.actual_activities; let lastItem = last;">
                                    <i class="fa fa-cube fa-lg ml-1" aria-hidden="true"></i>
            
                                    <span *ngIf="list.run_action_id" class="badge badge-pill" [ngClass]="actionBadgeDisplay(list.run_action_id)">
                                            {{actionNameDisplay(list.run_action_id)}}
                                    </span>&nbsp;

                                    <a *ngIf="list.run_action_id != 8" data-toggle="tooltip" title="Edit Date and Location"
                                    placement="top" (click)="openEditActivityModal(list.id,'actual')"><i
                                        class="fa fa-fw fa-pencil"></i>&nbsp;</a>
    
                                    <a *ngIf="list.pickup_docket_file != '' && list.run_action_id == 1"
                                        href="{{fileStoragePath}}/{{list.pickup_docket_folder_path}}/{{list.pickup_docket_file}}"
                                        target="_blank" title="View Pickup Docket File">
                                        <i class="fa fa-file mr-1" aria-hidden="true"></i>
                                    </a>
        
                                    <a *ngIf="list.release_docket_file != '' && list.run_action_id == 3"
                                        href="{{fileStoragePath}}/{{list.release_docket_folder_path}}/{{list.release_docket_file}}"
                                        target="_blank" title="View Release Docket File">
                                        <i class="fa fa-file mr-1" aria-hidden="true"></i>
                                    </a>
        
                                    <a *ngIf="list.collect_docket_file != '' && list.run_action_id == 4"
                                        href="{{fileStoragePath}}/{{list.collect_docket_folder_path}}/{{list.collect_docket_file}}"
                                        target="_blank" title="View Collect Docket File">
                                        <i class="fa fa-file mr-1" aria-hidden="true"></i>
                                    </a>
        
                                    <a *ngIf="list.delivery_docket_file != '' && list.run_action_id == 2"
                                        href="{{fileStoragePath}}/{{list.delivery_docket_folder_path}}/{{list.delivery_docket_file}}"
                                        target="_blank" title="View Delivery Docket File">
                                        <i class="fa fa-file mr-1" aria-hidden="true"></i>
                                    </a>

                                    <ng-container *ngIf="compareDates(list.start, list.end);else elseSameDate">
                                        <p class="d-inline mb-0">{{list.start | date:'EE, d MMM y hh:mm a'}} - {{list.end | date:'EE, d MMM y hh:mm a'}}</p>
                                    </ng-container>
            
                                    <ng-template #elseSameDate>
                                        <p class="d-inline mb-0">{{list.start | date:'EE, d MMM y hh:mm a'}} - {{list.end | date:'hh:mm a'}}</p>
                                       </ng-template>

                                       <div class="row">
                                           <div class="col-1 d-flex align-items-center justify-content-center">
                                               <div *ngIf="!lastItem && ((list.connote_control_no != null ||(list.run_action_id == 3 || list.run_action_id == 4)) && list.location_id !=null)" class="timeline-line"></div>
                                               <div *ngIf="!lastItem && ((list.connote_control_no == null ||(list.run_action_id == 3 || list.run_action_id == 4)) || list.location_id ==null)" class="timeline-line"></div>
                                           </div>
                                           <div class="col-11 pl-0 mb-3">
                                               <div class="row">
                                                <div *ngIf="list.run_action_id != 12 && locationStringDisplay(list) != '' " class="col-md-12">
                                                    <i class="fa fa-map-marker ml-1 mr-1" aria-hidden="true"></i>
                                                    <p class="d-inline mb-0">
                                                        {{locationStringDisplay(list)}}
                                                    </p>
                                                </div>
                                                   <div class="col-md-12" *ngIf="list.connote_control_no != null">
                                                       <p class="mb-0">
                                                           Connote Reference :
                                                           <a class="font-weight-bold secondary-link" title="Go to Connote Page" (click)="viewConnote(list.connote_control_no)">
                                                               {{list.connote_control_no}}
                                                           </a>
                                                           <span *ngIf="list.customer_name"> of {{list.customer_name}}</span>
                                                       </p>
                                                   </div>
                                                   <div class="col-md-12">
                                                       <p class="mb-0" *ngIf="list.personnel_print_name">
                                                           Personnel: {{list.personnel_print_name}}
                                                       </p>

                                                       <p class="mb-0" *ngIf="list.notes != null">
                                                           Notes: {{list.notes}}
                                                       </p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                   </div> <br>
                               </ng-template>
                           </div>
                           <div class="tab-pane" id="tb">
                                <div *ngFor="let phases of runData?.plan_activities; let count = index;">
                                    <div *ngFor="let list of phases; let lastItem = last;">
                                        <i class="fa fa-cube fa-lg ml-1" aria-hidden="true"></i>&nbsp;
                                        <span *ngIf="list.run_action_id" class="badge badge-pill" [ngClass]="actionBadgeDisplay(list.run_action_id)">
                                            {{actionNameDisplay(list.run_action_id)}}
                                        </span>&nbsp;
                                        <span *ngIf="list.is_done"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;</span>
                                        <span *ngIf="!list.is_done"><i class="fa fa-fw fa-pencil-square-o" aria-hidden="true" (click)="openEditActivityModal(list,'planned')" ngbTooltip="Edit Time/Location"></i>&nbsp;</span>
                                        <ng-container
                                            *ngIf="compareDates(list.start_datetime, list.end_datetime);else elseSameDate">
                                            <p class="d-inline mb-0">{{list.start_datetime | date:'d MMM y hh:mm a'}} - {{list.end_datetime | date:'d MMM y hh:mm a'}}</p>
                                        </ng-container>
                
                                        <ng-template #elseSameDate>
                                            <p class="d-inline mb-0">{{list.start_datetime | date:'EE, d MMM y hh:mm a'}} - {{list.end_datetime |
                                                date:'hh:mm a'}}</p>
                                        </ng-template>

                                        <div class="row">
                                            <div class="col-1 d-flex align-items-center justify-content-center">
                                                <div *ngIf="!lastItem && (list.connote_control_no != null && list.location_id !=null)" class="timeline-line"></div>
                                                <div *ngIf="!lastItem && (list.connote_control_no == null && list.location_id ==null)" class="timeline-line"></div>
                                            </div>
                                            <div class="col-11 pl-0 mb-3">
                                                <div class="row">
                                                    <div *ngIf="list.run_action_id != 12 && locationStringDisplay(list) != '' " class="col-md-12">
                                                        <i class="fa fa-map-marker ml-1 mr-1" aria-hidden="true"></i>
                                                        <p class="d-inline mb-0">
                                                            {{locationStringDisplay(list)}}
                                                        </p>
                                                    </div>

                                                    <div class="col-md-12" *ngIf="list.connote_control_no != null">
                                                        <p class="mb-0">
                                                            Connote Reference :
                                                            <a class="font-weight-bold secondary-link" title="Go to Connote Page" (click)="viewConnote(list.connote_control_no)">
                                                                {{list.connote_control_no}}
                                                            </a>
                                                            <span *ngIf="list.customer_name"> of {{list.customer_name}}</span>
                                                        </p>
                                                        <ng-container *ngIf="list.run_action_id != 3 || list.run_action_id != 4 || list.run_action_id != 9 || list.run_action_id != 10">
                                                            Connote Details: 
                                                            <a class="text-blue" (click)="editActivity(list);" placement="bottom" ngbTooltip="Edit Details">
                                                                <i class="fa fa-pencil"></i>&nbsp;
                                                            </a>
                                                            <span container="body">
                                                                {{list.connote_contact_name}} {{(list.connote_contact_name!=null && list.connote_contact_no)?' / ':''}}
                                                                {{list.connote_contact_no}}
                                                                {{((list.connote_contact_name!=null || list.connote_contact_no!=null) && list.connote_contact_email!=null)? ' / ':''}}
                                                                {{list.connote_contact_email}}
                                                            </span><br>
                                                            <span *ngIf="list.connote_notes!=null" container="body">Notes: {{list.connote_notes}}</span>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> 
                                    </div>
                                    <ng-container *ngIf="runData?.plan_activities.length > 1">
                                        <span style="display: flex; justify-content: center">
                                            <small>End of Phase {{count+1}}</small>
                                        </span>
                                        <hr class="dotted-line">
                                    </ng-container>
                                </div>
                           </div>
                       </div>
                   </div>
               </div>
               <div>
                <div widget class="card border-0 box-shadow mb-3" *ngIf="positions?.length > 0">
                    <div class="card-header transparent border-0 text-muted">
                        <div class="row">
                            <div class="col-md-9">
                                <h5>Breach Map</h5>
                            </div>
                        </div>
                        <div class="col-md-14">
                            <ngui-map zoom="{{mapZoom}}" center="{{centerLat}},{{centerLng}}" style="height:500px; width:100%;">
                                <marker *ngFor="let pos of positions" [position]="pos" (click)="clickMarker($event, pos)">
                                </marker>
                                <marker *ngIf="trail" icon="assets/img/app/marker.png" [position]="trail">
                                </marker>
                                <marker *ngFor="let geo of geofences" [position]="geo" (click)="clickGeofence($event, geo)">
                                    <circle fillColor="black" radius="{{geo.radius}}" center="{{geo.lat}},{{geo.lng}}">
                                    </circle>
                                </marker>
                                <info-window id="iwg" maxWidth="400" maxHeight="400">
                                    <div *ngIf="geofenceInfo?.display">
                                        <div widget class="card border-0 box-shadow">
                                            <div class="card-header transparent border-0 text-muted text-center">
                                                <h6>{{geofenceInfo?.controlNumber}}</h6>
                                            </div>
                                            <div class="card-body pt-0 widget-body">
                                                <div>
                                                    <small>
                                                        <span class="text-gray">RADIUS: </span> <strong
                                                            class="text-primary">{{geofenceInfo.radius}}</strong> <br />
                                                        <span class="text-gray">TASK: </span> <strong
                                                            class="text-primary">{{geofenceInfo.runActionlabel}}</strong><br />
                                                        <span class="text-gray">GEOFENCE LOCATION: </span> <strong
                                                            class="text-primary">{{geofenceInfo.plannedLat}},{{geofenceInfo.plannedLng}}</strong><br />
                                                        <span class="text-gray">GEOFENCE ADDRESS: </span> <strong
                                                            class="text-primary">{{geofenceInfo.plannedLocation}}</strong><br />
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </info-window>
                                <info-window id="iwd" maxWidth="400" maxHeight="400">
                                    <div *ngIf="driverInfo?.display">
                                        <div widget class="card border-0 box-shadow">
                                            <div class="card-header transparent border-0 text-muted text-center">
                                                <h6>{{driverInfo?.driverName}}</h6>
                                            </div>
                                            <div class="card-body pt-0 widget-body">
                                                <div>
                                                    <small>
                                                        <span class="text-gray">CONTROL NUMBER: </span> <strong
                                                            class="text-primary">{{driverInfo.controlNumber}}</strong><br />
                                                        <span class="text-gray">TASK: </span> <strong
                                                            class="text-primary">{{driverInfo.runActionlabel}}</strong><br />
                                                        <span class="text-gray">BREACH LOCATION: </span> <strong
                                                            class="text-primary">{{driverInfo.lat}},{{driverInfo.lng}}</strong> <br />
                                                        <span class="text-gray">BREACH ADDRESS: </span> <strong
                                                            class="text-primary">{{driverInfo.address}}</strong> <br />
                                                        <span class="text-gray">TASK ADDRESS: </span> <strong
                                                            class="text-primary">{{driverInfo.plannedLocation}}</strong><br />
                                                        <span class="text-gray">BREACH TIMESTAMP: </span> <strong
                                                            class="text-primary">{{driverInfo.breachtimestamp| date:'d MMM y'}},
                                                            {{driverInfo.breachtimestamp| date:'shortTime'}}</strong><br />
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </info-window>
                            </ngui-map>
                        </div>
                    </div>
                </div>
            </div>
           </div>

           <div class="col-md-4">
               
               <div widget class="card border-0 box-shadow">
                   <div class="card-header transparent border-0 text-muted">
                       <h5>Dispatch Logs</h5>
                       <div class="clearfix">
                           <ul class="nav nav-tabs top">
                               <li class="nav-item">
                                    <a class="nav-link active" data-toggle="tab" href="#breach_location"><small>Location Breach</small></a>
                               </li>
                               <li class="nav-item">
                                   <a class="nav-link" data-toggle="tab" href="#breach_time"><small>Time Breach</small></a>
                               </li>
                               <li class="nav-item">
                                   <a class="nav-link" data-toggle="tab" href="#history_logs"><small>Trip History</small></a>
                               </li>
                               <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#qar"><small>QAR</small></a>
                              </li>
                              <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#firebase_logs"><small>Location History</small></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#volvo" *ngIf="(runData?.run_status_id == '3' && runData?.volvo == true) || (runData?.run_status_id == '4' && runData?.volvo_records != false)"><small>Volvo</small></a>
                            </li>
                           </ul>
                       </div>
                       <div class="tab-content top">
                           <div class="tab-pane active" id="breach_location">  
                               <div class="row pt-1" *ngFor="let breach of locationBreaches;let lastItem = last;let ind = index">
                                   <!-- Date created of Breach request -->
                                   <div class="col-lg-12 mb-2">
                                       <p class="mb-0 breach-text"> 
                                           <ng-container *ngFor="let driver of clonedRun?.driver">
                                               <ng-container *ngFor="let activity of clonedRun?.plan_activities" >
                                                   <ng-container *ngIf="activity.id == breach.breachable_id || activity.run_plan_activity_id == breach.breachable_id">
                                                       <ng-container *ngFor="let action of run_actions">
                                                           <ng-container *ngIf="action.id==activity.run_action_id">
                                                               <ng-container *ngIf="breach.reason"><b>{{driver?.first_name}} {{driver?.last_name}}</b> requested to breach {{action?.label | titlecase}} task.  
                                                                <a class="hover danger pull-right" title="Invalidate Record" (click)="openModalDeleteBreach(breach.breachable.run_plan_activity_id)"><i class="fa fa-sm  fa-trash mr-1 p-1" aria-hidden="true"></i></a>
                                                                <a class="hover primary pull-right" title="Locate on breach map" (click)="onSelect(breach)"><i class="fa fa-sm  fa-map-marker mr-1 p-1" aria-hidden="true"></i></a>
                                                                <a *ngIf="!btnStatuses[ind] && btnDisable[ind]"  class="hover primary pull-right" title="Play location history" (click)="playLocationHistory(breach.breachable.run_plan_activity_id,ind)"><i class="fa fa-sm fa-play-circle mr-1 p-1" aria-hidden="true"></i></a>
                                                                <a *ngIf="btnStatuses[ind] && btnDisable[ind]" class="hover primary pull-right" title="Stop location history replay" (click)="stopLocationHistory(ind)"><i class="fa fa-sm fa-pause-circle-o mr-1 p-1" aria-hidden="true"></i></a>
                                                                <br>
                                                                 <b>Driver's reason:</b> {{breach?.reason}}.<br>
                                                               </ng-container>
                                                           </ng-container>
                                                       </ng-container>
                                                   </ng-container>
                                               </ng-container>
                                           </ng-container>
                                           <!-- Admin Name -->
                                           <ng-container *ngFor="let admin of members">
                                               <ng-container *ngIf="admin.id == breach.breach_response?.evaluated_by">
                                                   <span class="font-weight-bold">{{admin.display_name | titlecase}} </span>
                                               </ng-container>
                                           </ng-container>
       
                                           <!-- Status of breach request -->
                                           <ng-container *ngIf="breach.breach_response == null">Awaiting approval of </ng-container>
                                           <ng-container *ngIf="breach.breach_response?.breach_response_action?.id == 'accept' && breach.breach_response?.evaluated_by != null">accepts </ng-container>
                                           <ng-container *ngIf="breach.breach_response?.breach_response_action?.id == 'accept' && breach.breach_response?.evaluated_by == null">Automatically accepts </ng-container>
                                           <ng-container *ngIf="breach.breach_response?.breach_response_action?.id == 'reject'">rejects </ng-container>
                                           <ng-container *ngIf="breach.breach_response?.breach_response_action?.id == 'reject' && breach.breach_response?.evaluated_by == null">Automatically accepts </ng-container>
       
                                           <!-- Get driver with breach request-->
                                           <ng-container *ngFor="let driver of clonedRun?.driver; let first = first;">
                                               
                                               <ng-container *ngIf="driver.user_id==breach.requested_by.id;else catchUndefinedDriver"> 
                                                   {{driver.first_name}}'s request to record the breached
       
                                                   <!-- Identify linked planned activity and its job action -->
                                                   <ng-container *ngFor="let activity of clonedRun?.plan_activities">
                                                       <ng-container *ngIf="activity.id == breach.breachable_id || activity.run_plan_activity_id == breach.breachable_id">
                                                           <span *ngIf="activity.id == breach.breachable_id">planned </span>
                                                           <ng-container *ngFor="let action of run_actions">
                                                               <ng-container *ngIf="action.id==activity.run_action_id">
                                                                   <span class="text-white badge badge-pill" [ngClass]="actionBadgeDisplay(activity.run_action_id)">
                                                                   <span *ngIf="clonedRun?.run_type_id == 1">
                                                                       <ng-container *ngIf="activity.run_action_id != 8 && activity.run_action_id != 5 && activity.run_action_id != 6 &&
                                                                       activity.run_action_id != 12 && activity.run_action_id != 13">Local&nbsp;</ng-container>
                                                                   </span>
                                                                       {{action.label | titlecase}}
                                                                       <ng-container *ngIf="activity.run_action_id == 5 || activity.run_action_id == 6">Trip</ng-container>
                                                                       <ng-container *ngIf="activity.run_action_id == 12 || activity.run_action_id == 13">Job</ng-container>
                                                                   </span>
                                                                   activity of 
                                                                   <span class="font-weight-bold">{{activity.connote_control_no}}</span>
                                                                   connote.<br>
                                                               </ng-container>
                                                           </ng-container>
                                                       </ng-container>
                                                   </ng-container>
                                                   <ng-container *ngFor="let activity of clonedRun?.plan_activities">
                                                       <ng-container *ngIf="activity.id == breach.breachable_id || activity.run_plan_activity_id == breach.breachable_id">
                                                   <ng-container><b>Admin's reason:</b> {{breach.breach_response.reason}}</ng-container><br>
                                               </ng-container>
                                           </ng-container>
                                               </ng-container> 
                                               <ng-template #catchUndefinedDriver>
                                               
                                                   <ng-container *ngIf="first == 1">
                                                       the driver's request to record the
       
                                                       <!-- Identify linked planned activity and its job action -->
                                                       <ng-container *ngFor="let activity of clonedRun?.plan_activities">
                                                           <ng-container *ngIf="activity.id == breach.breachable_id || activity.run_plan_activity_id == breach.breachable_id">
                                                               <ng-container *ngFor="let action of run_actions">
                                                                   <ng-container *ngIf="action.id==activity.run_action_id">
                                                                       <span class="text-white badge badge-pill" [ngClass]="actionBadgeDisplay(activity.run_action_id)">
                                                                           {{action.label | titlecase}}
                                                                           <ng-container *ngIf="activity.run_action_id == 5 || activity.run_action_id == 6">Trip</ng-container>
                                                                           <ng-container *ngIf="activity.run_action_id == 12 || activity.run_action_id == 13">Job</ng-container>
                                                                       </span>
                                                                       activity of 
                                                                       <span class="font-weight-bold">{{activity.connote_control_no}}</span>
                                                                       connote.
                                                                   </ng-container>
                                                               </ng-container>
                                                           </ng-container>
                                                       </ng-container>
                                                   </ng-container>
       
                                               </ng-template>
                                           </ng-container> 
       
                                           <span class="blockquote-footer text-right"> {{breach.created_at| date:'d MMM y'}}, {{breach.created_at| date:'shortTime'}}</span>
                                       </p>
                                       
                                       <hr *ngIf="!lastItem" class="mb-0">
                                   </div>
                               </div>
       
                               <div class="" *ngIf="locationBreaches.length == 0"><i>No recorded breaches.</i></div>
                           </div>
                           <div class="tab-pane" id="breach_time">  
                               <div class="row pt-1" *ngFor="let breach of timeBreaches;let lastItem = last">
                                   <!-- Date created of Breach request -->
                                   <div class="col-lg-12 mb-2">
                                       <p class="mb-0">
                                           <ng-container *ngFor="let driver of clonedRun?.driver">
                                               <ng-container *ngFor="let activity of clonedRun?.actual_activities">
                                                   <ng-container *ngIf="activity.id == breach.breachable_id || activity.run_plan_activity_id == breach.breachable_id">
                                                       <ng-container *ngFor="let action of run_actions">
                                                           <ng-container *ngIf="action.id==activity.run_action_id">
                                                               <ng-container *ngIf="breach.reason"><b>{{driver?.first_name}} {{driver?.last_name}}</b> requested to breach {{action?.label | titlecase}} task.<br>
                                                                 <b>Driver's reason:</b> {{breach?.reason}}.<br>
                                                               </ng-container>
                                                           </ng-container>
                                                       </ng-container>
                                                   </ng-container>
                                               </ng-container>
                                           </ng-container>
                                           <!-- Admin Name -->
                                           <ng-container *ngFor="let admin of members">
                                               <ng-container *ngIf="admin.id == breach.breach_response?.evaluated_by">
                                                   <span class="font-weight-bold">{{admin.display_name | titlecase}} </span>
                                               </ng-container>
                                           </ng-container>
       
                                           <!-- Status of breach request -->
                                           <ng-container *ngIf="breach.breach_response == null">Awaiting approval of </ng-container>
                                           <ng-container *ngIf="breach.breach_response?.breach_response_action?.id == 'accept' && breach.breach_response?.evaluated_by != null">accepts </ng-container>
                                           <ng-container *ngIf="breach.breach_response?.breach_response_action?.id == 'accept' && breach.breach_response?.evaluated_by == null">Automatically accepts </ng-container>
                                           <ng-container *ngIf="breach.breach_response?.breach_response_action?.id == 'reject'">rejects </ng-container>
                                           <ng-container *ngIf="breach.breach_response?.breach_response_action?.id == 'reject' && breach.breach_response?.evaluated_by == null">Automatically accepts </ng-container>
       
                                           <!-- Get driver with breach request-->
                                           <ng-container *ngFor="let driver of clonedRun?.driver; let first = first;">
                                               
                                               <ng-container *ngIf="driver.user_id==breach.requested_by.id;else catchUndefinedDriver"> 
                                                   {{driver.first_name}}'s request to record the breached
       
                                                   <!-- Identify linked planned activity and its job action -->
                                                   <ng-container *ngFor="let activity of clonedRun?.actual_activities">
                                                       <ng-container *ngIf="activity.id == breach.breachable_id || activity.run_plan_activity_id == breach.breachable_id">
                                                           <span *ngIf="activity.id == breach.breachable_id">unplanned </span>
                                                           <span *ngIf="activity.run_plan_activity_id == breach.breachable_id">planned </span>
                                                           <ng-container *ngFor="let action of run_actions">
                                                               <ng-container *ngIf="action.id==activity.run_action_id">
                                                                   <span class="text-white badge badge-pill" [ngClass]="actionBadgeDisplay(activity.run_action_id)">
                                                                   <span *ngIf="clonedRun?.run_type_id == 1">
                                                                       <ng-container *ngIf="activity.run_action_id != 8 && activity.run_action_id != 5 && activity.run_action_id != 6 &&
                                                                       activity.run_action_id != 12 && activity.run_action_id != 13">Local&nbsp;</ng-container>
                                                                   </span>
                                                                       {{action.label | titlecase}}
                                                                       <ng-container *ngIf="activity.run_action_id == 5 || activity.run_action_id == 6">Trip</ng-container>
                                                                       <ng-container *ngIf="activity.run_action_id == 12 || activity.run_action_id == 13">Job</ng-container>
                                                                   </span>
                                                                   activity of 
                                                                   <span class="font-weight-bold">{{activity.connote_control_no}}</span>
                                                                   connote.<br>
                                                               </ng-container>
                                                           </ng-container>
                                                       </ng-container>
                                                   </ng-container>
                                                   <ng-container *ngFor="let activity of clonedRun?.actual_activities">
                                                       <ng-container *ngIf="activity.id == breach.breachable_id || activity.run_plan_activity_id == breach.breachable_id">
                                                   <ng-container><b>Admin's reason:</b> {{breach.breach_response.reason}}</ng-container><br>
                                               </ng-container>
                                           </ng-container>
                                               </ng-container> 
                                               <ng-template #catchUndefinedDriver>
                                               
                                                   <ng-container *ngIf="first == 1">
                                                       the driver's request to record the
       
                                                       <!-- Identify linked planned activity and its job action -->
                                                       <ng-container *ngFor="let activity of clonedRun?.actual_activities">
                                                           <ng-container *ngIf="activity.id == breach.breachable_id || activity.run_plan_activity_id == breach.breachable_id">
                                                               <ng-container *ngFor="let action of run_actions">
                                                                   <ng-container *ngIf="action.id==activity.run_action_id">
                                                                       <span class="text-white badge badge-pill" [ngClass]="actionBadgeDisplay(activity.run_action_id)">
                                                                           {{action.label | titlecase}}
                                                                           <ng-container *ngIf="activity.run_action_id == 5 || activity.run_action_id == 6">Trip</ng-container>
                                                                           <ng-container *ngIf="activity.run_action_id == 12 || activity.run_action_id == 13">Job</ng-container>
                                                                       </span>
                                                                       activity of 
                                                                       <span class="font-weight-bold">{{activity.connote_control_no}}</span>
                                                                       connote.
                                                                   </ng-container>
                                                               </ng-container>
                                                           </ng-container>
                                                       </ng-container>
                                                   </ng-container>
       
                                               </ng-template>
                                           </ng-container> 
       
                                           <span class="blockquote-footer text-right"> {{breach.created_at| date:'d MMM y'}}, {{breach.created_at| date:'shortTime'}}</span>
                                       </p>
                                       
                                       <hr *ngIf="!lastItem" class="mb-0">
                                   </div>
                               </div>
       
                               <div class="" *ngIf="timeBreaches.length == 0"><i>No recorded breaches.</i></div>
                           </div>
                           <div class="tab-pane" id="history_logs" *ngIf="loadingIndicator == false" style="max-height:650px;overflow-y:scroll;overflow-x:hidden;">
                               <div class="row pt-1" *ngFor="let log of runData?.history;let lastItem = last;">
                                   <div class="col-lg-12 mb-2">
                                       <span class="badge badge-pill badge-secondary">{{ log.created_at | date: 'dd MMM yyyy h:mm a'}}</span>
                                       <small class="mb-0"><i style="color:blue" *ngIf="log.admin_name"> {{log.admin_name}}:</i>
                                        {{log.description}}</small>
                                   </div>
                               </div>
                           </div>

                           <div class="tab-pane" id="qar" >  
                            <div  *ngIf="runData?.ncr == 0" class="mb-2 mt-2" style="justify-content: center;display: flex;min-width: 50%;margin:auto" ><i>There was no QAR recorded.</i></div>


                            <div style="text-align:center;">
                                    <button type="button" class="btn btn-secondary btn-sm mb-1" aria-expanded="false" placement="bottom" ngbTooltip="Add New QAR" (click)="openNCRModal(null)">
                                        <span class="sr-only">Add QAR</span>
                                        <i class="fa fa-lg fa-plus"></i>
                                        <span>&nbsp;Add QAR</span>
                                    </button>
                            </div>
                            <div style="max-height:650px;overflow-y:scroll;overflow-x:hidden;">
                            <div class="row pt-1" *ngFor="let ncr of runData?.ncr;let lastItem = last">
                                <div class="col-lg-12 mb-2">
                                    <div class="row">
                                        <div class="col-12 my-1"> 
                                            <p style="text-align: center;font-size: medium;font-weight:bold;">{{ncr?.control_no}}
                                            <a class="cursorhover pull-right" title="Delete QAR" *ngIf="ncr.status_id == 1" (click)="openModalDeleteNCR(ncr)"><i class="fa fa-sm fa-trash mr-2"></i></a>
                                            <a class="hover difot pull-right"  title="Edit QAR" (click)="openNCRModal(ncr)"><i class="fa fa-sm fa-edit mr-1"></i></a></p>
                                        </div>
                                        <div class="col-4 align-items-center d-flex my-1"><h6><b>Category:</b></h6></div> <div class="col-8 align-items-center d-flex my-1">{{ncr?.category}}</div>
                                        <div class="col-4 align-items-center d-flex my-1"><b>Code:</b></div><div class="col-8 align-items-center d-flex my-1"> {{ncr?.code}}</div>  
                                        <div class="col-4 align-items-center d-flex my-1"><b>Classification:</b></div><div class="col-8 align-items-center d-flex my-1">{{ncr?.classification}} </div>
                                        <div class="col-4 align-items-center d-flex my-1"> <b>Description:</b></div><div class="col-8 align-items-center d-flex my-1">{{ncr?.problem_details}}</div>
                                        <div class="col-4 align-items-center d-flex my-1"><b>Status:</b></div>
                                        <div class="col-8 align-items-center d-flex my-1"> <span class="badge badge-pill" [ngClass]="{'badge-success': ncr?.status_id == 3,
                                        'badge-secondary': ncr?.status_id == 1,
                                        'badge-danger': ncr?.status_id == 5,
                                        'badge-warning': ncr?.status_id == 4,
                                        'badge-primary': ncr?.status_id == 2
                                        }">{{ncr?.status}}</span></div>
                                        <div class="col-4 align-items-center d-flex my-1"> <b>File:</b></div> <div class="col-8 align-items-center d-flex my-1"><a href="{{fileStoragePath}}/ncr/{{ncr?.file}}" target="_blank"> {{ncr?.file}}</a></div> 
                                    </div>
                                    <hr *ngIf="!lastItem" class="mb-0">
                            </div>    
                        </div>
                        </div>
                    </div>
                    
                           <div class="tab-pane" id="firebase_logs" style="max-height:650px;overflow-y:scroll;overflow-x:hidden;">
                            <div *ngIf="firebaseLogs?.length > 0 ; else emptyLogs">
                                <div class="row pt-1" *ngFor="let log of firebaseLogs">
                                    <div class="col-lg-12 mb-2">
                                        <span class="badge badge-pill badge-secondary">{{ log.number_timestamp | date: 'dd MMM yyyy h:mm a'}}</span>
                                        <small class="mb-0"> {{log.sub_thoroughfare}} {{log.thoroughfare}} {{log.locality}} {{log.administrative_area}} {{log.postal_code}}</small>
                                    </div>
                                </div>
                            </div>
                           <ng-template #emptyLogs>
                               <i>No recorded location.</i>
                           </ng-template>
                        </div>

                        <div class="tab-pane" id="volvo" style="text-align: center;">      
                            <ngx-loading [show]="volvo_loadingIndicator"></ngx-loading>          
                            <button type="button" class="btn btn-sm btn-success" (click)="getVolvo()" ngbAutofocus *ngIf="volvo_connect == false && runData?.run_status_id == '3'">Connect to Volvo
                            </button>

                            <div  *ngIf="volvo_connect == true && volvo_message != null && runData?.run_status_id == '3'">
                                <div  *ngIf="volvo_result == '403' ||volvo_result == '404' ||volvo_result == '400'" style="margin-left:auto;margin-right:auto;"><i>{{volvo_message}}</i></div>   
                                <div  *ngIf="volvo.length == 0 && volvo_result == '200'" style="margin-left:auto;margin-right:auto;"><i>There was no Volvo recorded.</i></div>   
                                <span *ngIf="volvo.length > 0 && volvo_result == '200'">
                                        <div class="row pt-1" *ngFor="let v of volvo| paginate: { itemsPerPage: 10, currentPage: volvo_page };let lastItem = last">
                                                <div class="col-4 align-items-center d-flex my-1"><small><i class="fa fa-power-off ml-2 mr-1" style="color:red" *ngIf="v.trigger_type == 'IGNITION_OFF'"></i>
                                                    <i class="fa fa-power-off ml-2 mr-1" style="color:green" *ngIf="v.trigger_type == 'IGNITION_ON'"></i>{{v.trigger_type}}</small></div> 
                                                <div class="col-4 align-items-center d-flex my-1"><small>{{ v.date | date: 'dd MMM yyyy h:mm a'}}</small></div> 
                                                <div class="col-4 align-items-center d-flex my-1"><small>{{v.address}}</small></div> 
                                                <hr *ngIf="!lastItem" class="mb-1"> 
                                        </div>
                                        <div style="justify-content: center;display: flex;min-width: 100%">
                                            <div>
                                                <div>
                                                    <div class="col-12 align-items-center d-flex my-1" style="justify-content: center;"> <small><pagination-controls autoHide="true" (pageChange)="volvo_page = $event" maxSize="10"></pagination-controls></small></div>
                                                </div>  
                                            </div>
                                        </div> 
                                </span>
                                    
                            </div>

                            <div  *ngIf="runData?.run_status_id == '4' && runData?.volvo_records != false"> 
                                    <div class="row pt-1" *ngFor="let v of runData?.volvo_records| paginate: { itemsPerPage: 10, currentPage: volvo_page };let lastItem = last">
                                        <div class="col-4 align-items-center d-flex my-1"><small><i class="fa fa-power-off ml-2 mr-2" style="color:red" *ngIf="v.trigger_type == 'IGNITION_OFF'"></i>
                                             <i class="fa fa-power-off ml-2 mr-2" style="color:green" *ngIf="v.trigger_type == 'IGNITION_ON'"></i>{{v.trigger_type}}</small></div> 
                                        <div class="col-4 align-items-center d-flex my-1"><small>{{ v.date | date: 'dd MMM yyyy h:mm a'}}</small></div> 
                                         <div class="col-4 align-items-center d-flex my-1"><small>{{v.address}}</small></div> 
                                         <hr *ngIf="!lastItem" class="mb-1">  
                                    </div>
                                    <div style="justify-content: center;display: flex;min-width: 100%">
                                        <div>
                                            <div>
                                                <div class="col-12 align-items-center d-flex my-1" style="justify-content: center;"> <small><pagination-controls autoHide="true" (pageChange)="volvo_page = $event" maxSize="10"></pagination-controls></small></div>
                                            </div>  
                                        </div>
                                    </div> 
                            </div>
                        </div>
                   </div>
               </div>
           </div>
       </div>
   </div>
</div>

   <!-- Add Notes -->
   <div class="col-md-2" *ngIf="!loadingIndicator">
       
    <div class="row mb-2">
        <div class="col">
            <div widget class="card border-0 box-shadow" *ngIf="runData.admin_notes !=null">
                <div class="card-header transparent border-0 text-muted">
                    <strong>Admin Notes</strong><br>
                    <p class="mt-2"> {{runData.admin_notes}}</p>
                </div>
            </div><br *ngIf="runData.admin_notes !=null">
            <div widget class="card border-0 box-shadow" *ngIf="runData.dispatch_notes !=null">
                <div class="card-header transparent border-0 text-muted">
                    <strong>Dispatch Notes</strong><br>
                    <p class="mt-2"> {{runData.dispatch_notes}}</p>
                </div>
            </div>
        </div>
    </div><br>
    <div class="row">
        <div class="col">
            <div style="padding-left: 4px;">
                <strong>Additional Notes</strong>&nbsp;
                <button class="btn btn-sm btn-gray mb-1" (click)="openModalNote(null)">
                    <i class="fa fa-plus"></i> 
                </button>
            </div>  
        </div>
    </div>

    <div *ngIf="notes.length == 0" class="row">
        <div class="col">
            <div class="alert alert-warning fade show" role="alert">
                <small>There are no notes for this connote yet. <a href="javascript:void(0);" (click)="openModalNote(null)">Add Notes</a> now.</small>
            </div>
        </div>
        
    </div>

    <ng-container *ngIf="notes.length > 0">
        <div class="row_notes mb-3" *ngFor="let note of notes; let i = index">
            <!-- <span *ngIf="i > 0"><br/></span> -->
            <div class="card alert-warning">

                <div class="row">
                    <div class="col-sm-12">
                        <small>
                            <i>&nbsp;  {{ (note.created_at !== null) ? (note.created_at | date: 'dd MMM yyyy h:mm a') : "No Date"}}</i>
                        </small>
                        
                        <a style="margin-left: 65px;" href="javascript:void(0);" (click)="openModalNote(note)"><i class="fa fa-pencil"></i></a>&nbsp;
                        <a href="javascript:void(0);" (click)="openModalDeleteNote(note)"><i class="fa fa-trash"></i></a>&nbsp;
                    </div>
                </div>
                
                <div>
                    <div class="col-md-12" style="padding: 8px;">
                        <p style="color:rgb(78, 69, 69);"> {{note.text}} </p>
                    </div>

                    <small *ngIf="note.updated_by == null">
                        <i>&nbsp; Created by: {{note.user}}</i>
                    </small>

                    <small *ngIf="note.updated_by !== null">
                        <i>&nbsp; Created by: {{note.user}} </i> <br>
                        <i>&nbsp; Updated by: {{note.updated_by}} </i>
                    </small>
                </div>

            </div>
        </div>
    </ng-container>
</div>
   
   <!-- START OF NOTE MODAL  -->
<ng-template #modalNote let-close="close">
   <div class="modal-header">
       <div class="col px-0" *ngIf="!isEditMode">
           <div class="row no-gutters pt-0">
               <span class="col-1"><i class="fa fa-2x fa-file-text-o" style="color:pink"></i></span>
               <div class="col"><h5 class="modal-title">Create New Note for {{runData.control_no}}</h5></div>
           </div>
       </div>
       <div class="col px-0" *ngIf="isEditMode">
           <div class="row no-gutters">
               <span class="col-1"><i class="fa fa-2x fa-file-text-o" style="color:pink"></i></span>
               <div class="col"><h5 class="modal-title">Edit Note</h5></div>
           </div>
       </div>
       <button type="button" class="close" (click)="close()">
           <span aria-hidden="true">&times;</span>
       </button>
   </div>

   <form [formGroup]="frmNote" novalidate (ngSubmit)="onSubmitNote(frmNote.value)">
       <div class="modal-body bg-gray">
           <div class="row pt-0">
               <div class="col-md-12">
                   <textarea rows="5" style="width:100%; padding-left: 4px; padding-right: 4px;" cols="70" formControlName="text" minlength="1" maxlength="1000"></textarea>
               </div>
           </div>

       </div>
       <div class="modal-footer">
           <button *ngIf="!isEditMode" type="submit" class="btn btn-sm btn-success" [disabled]="!frmNote.valid">Save</button>
           <button *ngIf="isEditMode" type="submit" class="btn btn-sm btn-success" [disabled]="!frmNote.valid">Save Changes</button>
           <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
       </div>
   </form>
</ng-template>
<!-- END OF NOTE MODAL  -->

<!-- START OF MODAL DELETE NOTE -->
<ng-template #modalDeleteNote let-close="close">
   <div class="modal-header">
       <div class="col px-0">
           <div class="row no-gutters pt-0">
               <span class="col-1"><i class="fa fa-2x fa-file-text-o" style="color:orange"></i></span>
               <div class="col ml-1"><h5 class="modal-title">&nbsp;Delete Note</h5></div>
           </div>
       </div>
      
       <button type="button" class="close" (click)="close()">
           <span aria-hidden="true">&times;</span>
       </button>
   </div>
   <div class="modal-body">
       <div class="row pt-0">
           <div class="col-md-12">
               <p class="mb-0">Do you really want to delete this note?</p> <br />
               <footer class="blockquote-footer" style="word-wrap: break-word;">{{note.text}}</footer>
           </div>
       </div>
   </div>
   <div class="modal-footer"><i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
       <button type="button" class="btn btn-sm btn-danger" (click)="onDeleteNote(note.id)"  [disabled]="spinner == true">Delete</button>
       <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
   </div>
</ng-template>
<!-- END OF MODAL DELETE NOTE -->

<!-- START OF MODAL GENERATE SDP -->
<ng-template #modalGenerate let-close="close">
   <div class="modal-header">
       <div class="col px-0">
           <div class="row no-gutters pt-0">
               <span class="col-1"><i class="fa fa-2x fa-file-text-o" style="color:orange"></i></span>
               <div class="col ml-1"><h5 class="modal-title">&nbsp;Generate New SDP</h5></div>
           </div>
       </div>
      
       <button type="button" class="close" (click)="close()">
           <span aria-hidden="true">&times;</span>
       </button>
   </div>
   <div class="modal-body">
       <div class="row pt-0">
           <div class="col-md-12">
               <p class="mb-0">Are you sure to regenerate new SDP file? This will overwrite the current SDP document.</p> <br />
               <p><i>Note: Kindly download current file before doing so to make your own copy. </i></p>
           </div>
       </div>
   </div>
   <div class="modal-footer"><i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
       <button type="button" class="btn btn-sm btn-success" (click)="generateSDP()" [disabled]="spinner == true" >Generate</button>
       <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
   </div>
</ng-template>
<!-- END OF MODAL GENERATE SDP -->

<!-- START OF MODAL EDIT ACTIVITY -->
<ng-template #modalEditActivity let-close="close">
   <div class="modal-header">
       <div class="col px-0">
           <div class="row no-gutters pt-0">
               <!-- <span class="col-1"><i class="fa fa-2x fa-file-text-o" style="color:orange"></i></span> -->
               <div class="col ml-1"><h5 class="modal-title">&nbsp;Edit Activity Date and Location</h5></div>
           </div>
       </div>
      
       <button type="button" class="close" (click)="close()">
           <span aria-hidden="true">&times;</span>
       </button>
   </div>
   <div class="modal-body" class="row pt-2">
       <div class="col-md-12" [formGroup]="frmActivity" >
           <div class="form-group col-md-12">
               <div class="row">
                   <ng-container *ngIf="selectedEvent.run_action_id != 12">
                       <div class="form-group col-md-12">
                           <h6>Location:</h6>
                           <div class="address">
                               <ngx-geo-autocomplete id="auto_location" (componentCallback)="pickupAddressCallback($event)"
                               [userSettings]="userSettings"></ngx-geo-autocomplete>
                               <small class="text-danger" *ngIf="!location_valid">*Location Required.<br></small>
                               <small *ngIf="!geometryValue" class="text-danger"><i>Information for the address is incorrect/incomplete, please selected another address.</i></small>
                           </div>
                           
                       </div>
                       <div class="form-group col-md-4">
                           <h6>Street # :</h6>
                           <input class="form-control form-control-sm" formControlName="street_no" type="text" disabled>
                       </div>
                       <div class="form-group col-md-8">
                           <h6>Street :</h6>
                           <input class="form-control form-control-sm" formControlName="street" type="text" disabled>
                       </div>
                       <div class="form-group col-md-4">
                           <h6>Suburb/City<span class="text-danger">*</span> :</h6>
                           <input class="form-control form-control-sm" formControlName="suburb" type="text" disabled>
                       </div>
                       <div class="form-group col-md-4">
                           <h6>State<span class="text-danger">*</span> :</h6>
                           <input class="form-control form-control-sm" formControlName="state" type="text" disabled>
                       </div>
                       <div class="form-group col-md-4">
                           <h6>Postal Code<span class="text-danger">*</span> :</h6>
                           <input class="form-control form-control-sm" formControlName="postal_code" type="text" disabled>
                       </div>
                   </ng-container >

                   <!-- start datetime -->
                   <div class="col-md-8" *ngIf="selectedEvent.action == 'actual'">
                       <div class="form-group">
                           <h6>Start date<span class="text-danger">*</span> :</h6>
                           <input class="form-control form-control-sm" formControlName="start_date" type="date" (change)="checkDates()" max="{{dateNow|date:'yyyy-MM-dd'}}">
                           <small class="text-danger" *ngIf="!checkDateTime">*Start date and time should not exceed end date and time!</small>
                       </div>
                   </div>

                   <div class="col-md-8"  *ngIf="selectedEvent.action == 'planned'">
                    <div class="form-group">
                        <h6>Start date<span class="text-danger">*</span> :</h6>
                        <input class="form-control form-control-sm" formControlName="start_date" type="date" (change)="checkDates()">
                        <small class="text-danger" *ngIf="!checkDateTime">*Start date and time should not exceed end date and time!</small>
                    </div>
                </div>

                   <div class="col-md-4">
                       <div class="form-group">
                           <h6>Start Time :</h6>
                           <ngb-timepicker formControlName="startdate_time"  [meridian]="false" (ngModelChange)="checkDates()"></ngb-timepicker>
                       </div>
                   </div>
               
               
                   <!-- end datetime -->
                   <div class="col-md-8" *ngIf="selectedEvent.action == 'actual'">
                       <div class="form-group">
                           <h6>End date<span class="text-danger">*</span> :</h6>
                           <input class="form-control form-control-sm" formControlName="end_date" type="date" (change)="checkDates()" max="{{dateNow|date:'yyyy-MM-dd'}}">
                       </div>
                   </div>
                   <div class="col-md-8"  *ngIf="selectedEvent.action == 'planned'">
                    <div class="form-group">
                        <h6>End date<span class="text-danger">*</span> :</h6>
                        <input class="form-control form-control-sm" formControlName="end_date" type="date" (change)="checkDates()">
                    </div>
                </div>
                   <div class="col-md-4">
                       <div class="form-group">
                           <h6>End Time :</h6>
                           <ngb-timepicker formControlName="enddate_time"  [meridian]="false" (ngModelChange)="checkDates()"></ngb-timepicker>
                       </div>
                   </div>
               </div>
           </div>
       </div>
   </div>
   <div class="modal-footer"><i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
       <button type="button" class="btn btn-sm btn-success" (click)="saveEvent(frmActivity.value,selectedEvent.action)" [disabled]="(!checkLocation() && selectedEvent.run_action_id != 12 && location_valid == false) || checkDateTime == false || spinner == true">Save</button>
       <button type="button" class="btn btn-sm btn-secondary" (click)="close()" [disabled]="spinner == true">Cancel</button>
   </div>
</ng-template>
<!-- END OF MODAL EDIT ACTIVITY -->

<!-- START OF MODAL GENERATE RELEASE DOCKET -->
<ng-template #modalRelease let-close="close">
   <div class="modal-header">
       <div class="col px-0">
           <div class="row no-gutters pt-0">
               <span class="col-1"><i class="fa fa-2x fa-file-text-o" style="color:orange"></i></span>
               <div class="col ml-1"><h5 class="modal-title">&nbsp;Generate New Release Docket</h5></div>
           </div>
       </div>
      
       <button type="button" class="close" (click)="close()">
           <span aria-hidden="true">&times;</span>
       </button>
   </div>
   <div class="modal-body">
       <div class="row pt-0">
           <div class="col-md-12">
               <p class="mb-0">Are you sure to regenerate new release docket? This will overwrite the current release docket.</p> <br />
               <p><i>Note: Kindly download current file before doing so to make your own copy. </i></p>
           </div>
       </div>
   </div>
   <div class="modal-footer"><i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
       <button type="button" class="btn btn-sm btn-success" (click)="generateReleaseDocket()" [disabled]="spinner == true" >Generate</button>
       <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
   </div>
</ng-template>
<!-- END OF MODAL RELEASE DOCKET-->

<!-- START OF MODAL GENERATE COLLECT DOCKET -->
<ng-template #modalCollect let-close="close">
   <div class="modal-header">
       <div class="col px-0">
           <div class="row no-gutters pt-0">
               <span class="col-1"><i class="fa fa-2x fa-file-text-o" style="color:orange"></i></span>
               <div class="col ml-1"><h5 class="modal-title">&nbsp;Generate New Collect Docket</h5></div>
           </div>
       </div>
      
       <button type="button" class="close" (click)="close()">
           <span aria-hidden="true">&times;</span>
       </button>
   </div>
   <div class="modal-body">
       <div class="row pt-0">
           <div class="col-md-12">
               <p class="mb-0">Are you sure to regenerate new collect docket? This will overwrite the current release docket.</p> <br />
               <p><i>Note: Kindly download current file before doing so to make your own copy. </i></p>
           </div>
       </div>
   </div>
   <div class="modal-footer"><i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
       <button type="button" class="btn btn-sm btn-success" (click)="generateCollectDocket()"  [disabled]="spinner == true" >Generate</button>
       <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
   </div>
</ng-template>
<!-- END OF MODAL COLLECT DOCKET-->


<!--  modal for documents -->
<ng-template #doc let-close="close">
   <div class="modal-header">
       <div class="col px-0">
           <div class="row no-gutters pt-0">
               <div class="col ml-1"><h5 class="modal-title">&nbsp;Documents</h5></div>
           </div>
       </div>
      
       <button type="button" class="close" (click)="close();resetDocVariables();getRun();">
           <span aria-hidden="true">&times;</span>                                                                                           
       </button>
   </div>
   <div class="modal-body">
       <div class="row pt-0">
           <div class="col-md-12">
               <div>
                   <p> <span style="color:red"><strong><i>Important Notice</i></strong></span> : 
                       <i style="color:gray;">Triggering generation of the document overwrites former file. You may download first to create copy of the existing file before doing so.</i>
                   </p>
                   <br/>

                   <table class="table table-sm table-striped">
                       <thead>
                           <tr>
                               <th width="10%">Operations</th>
                               <th width="30%">Document/s</th>
                               <th width="30%">Filename</th>
                               <th width="30%">Message</th>
                           </tr>
                       </thead>
                       <tbody>
                           <ng-container *ngFor="let con of connote_files">
                               <tr>
                                   <td width="10%">
                                       &nbsp;&nbsp;<button type="button" class="btn btn-outline-secondary btn-sm mb-1 mr-1" aria-expanded="false" (click)="generateFile('connote', con)"><span>Generate</span></button>
                                   </td>
                                   <td width="30%">Connote <br/><small class="text-primary"><i>*Generating connote document also regenerates its PPD, Pickup and Delivery Dockets</i></small></td>
                                   <td width="30%"><a href="{{fileStoragePath}}/connotes/{{con.file}}" target="_blank">{{con.file}}</a></td>
                                   <td width="30%">
                                       <i class="fa fa-spinner fa-spin" id="sp_connote{{con.id}}" style="display:none"></i>
                                       <span class="text-success font-italic" id="success_connote{{con.id}}" style="display:none">Successfully generated file/s.</span>
                                       <span class="text-warning font-italic" id="failed_connote{{con.id}}" style="display:none">Failed in generating the file/s.</span>
                                   </td>
                               </tr>
                           </ng-container>

                            <ng-container *ngFor="let pl of plabel_files">
                                <tr>
                                    <td width="10%">
                                        &nbsp;&nbsp;<button type="button" class="btn btn-outline-secondary btn-sm mb-1 mr-1" aria-expanded="false" (click)="generateFile('packaging_label', pl)"><span>Generate</span></button>
                                    </td>
                                    <td width="30%">Packaging Label</td>
                                    <td width="30%"><a href="{{fileStoragePath}}/packaging_label/{{pl.file}}" target="_blank">{{pl.file}}</a></td>
                                    <td width="30%">
                                        <i class="fa fa-spinner fa-spin" id="sp_packaging_label{{pl.id}}" style="display:none"></i>
                                        <span class="text-success font-italic" id="success_packaging_label{{pl.id}}" style="display:none">Successfully generated file.</span>
                                        <span class="text-warning font-italic" id="failed_packaging_label{{pl.id}}" style="display:none">Failed in generating the file.</span>
                                    </td>
                                </tr>
                            </ng-container>

                           <tr *ngIf="runData?.tripsheet_file != null">
                               <td width="10%">
                                   &nbsp;&nbsp;<button type="button" class="btn btn-outline-secondary btn-sm mb-1 mr-1" aria-expanded="false" (click)="generateFile('tripsheet', null)"><span>Generate</span></button>
                               </td>
                               <td width="30%">Tripsheet</td>
                               <td width="30%">
                                   <a  href="{{fileStoragePath}}/tripsheet/{{runData?.tripsheet_file}}" target="_blank">{{ runData?.tripsheet_file}} </a>
                                   <span *ngIf="runData?.tripsheet_file == null || runData?.tripsheet_file == ''"><i>No File Available.</i></span>
                               </td>
                               <td width="30%">
                                   <i class="fa fa-spinner fa-spin" *ngIf="sp_tripsheet"></i>
                                   <span class="text-success font-italic" *ngIf="success_tripsheet">Successfully generated file.</span>
                                   <span class="text-warning font-italic" *ngIf="failed_tripsheet">Failed in generating the file.</span>
                               </td>
                           </tr>
                           <ng-container *ngFor="let runsheet of runsheet_files">
                               <tr>
                                   <td width="10%">
                                       &nbsp;&nbsp;<button type="button" class="btn btn-outline-secondary btn-sm mb-1 mr-1" aria-expanded="false" (click)="generateFile('runsheet', null)"><span>Generate</span></button>
                                   </td>
                                   <td width="30%">Runsheet</td>
                                   <td width="30%"><a href="{{fileStoragePath}}/runsheet/{{runsheet.file == null ? runsheet : runsheet.file}}" target="_blank">{{runsheet.file == null ? runsheet : runsheet.file}}</a></td>
                                   <td width="30%">
                                       <i class="fa fa-spinner fa-spin" *ngIf="sp_runsheet"></i>
                                       <span class="text-success font-italic" *ngIf="success_runsheet">Successfully generated file.</span>
                                       <span class="text-warning font-italic" *ngIf="failed_runsheet">Failed in generating the file.</span>
                                   </td>
                               </tr>
                           </ng-container>
                           <ng-container *ngFor="let r_docket of release_docket_file">
                               <tr>
                                   <td width="10%">
                                       &nbsp;&nbsp;<button type="button" class="btn btn-outline-secondary btn-sm mb-1 mr-1" aria-expanded="false" (click)="generateFile('release_docket', r_docket.run_event_id)"><span>Generate</span></button>
                                   </td>
                                   <td width="30%">Release Docket</td>
                                   <td width="30%"><a href="{{fileStoragePath}}/{{r_docket.folder_path}}/{{r_docket.filename}}" target="_blank">{{r_docket.filename}}</a></td>
                                   <td width="30%">
                                       <i class="fa fa-spinner fa-spin" *ngIf="sp_drelease"></i>
                                       <span class="text-success font-italic" *ngIf="success_drelease">Successfully generated file.</span>
                                       <span class="text-warning font-italic" *ngIf="failed_drelease">Failed in generating the file.</span>
                                   </td>
                               </tr>
                           </ng-container>
                           <ng-container *ngFor="let c_docket of collect_docket_file">
                               <tr>
                                   <td width="10%">
                                       &nbsp;&nbsp;<button type="button" class="btn btn-outline-secondary btn-sm mb-1 mr-1" aria-expanded="false" (click)="generateFile('collect_docket', c_docket.run_event_id)"><span>Generate</span></button>
                                   </td>
                                   <td width="30%">Collect Docket</td>
                                   <td width="30%"><a href="{{fileStoragePath}}/{{c_docket.folder_path}}/{{c_docket.filename}}" target="_blank">{{c_docket.filename}}</a></td>
                                   <td width="30%">
                                       <i class="fa fa-spinner fa-spin" *ngIf="sp_dcollect"></i>
                                       <span class="text-success font-italic" *ngIf="success_dcollect">Successfully generated file.</span>
                                       <span class="text-warning font-italic" *ngIf="failed_dcollect">Failed in generating the file.</span>
                                   </td>
                               </tr>
                           </ng-container>
                           <tr *ngIf="runData?.run_type_id !=1 && runData?.run_type_id !=6 && (runData?.total_klms > 500 || is_multiple_connotes)">
                               <td width="10%" >
                                   &nbsp;&nbsp;<button type="button" class="btn btn-outline-secondary btn-sm mb-1 mr-1" aria-expanded="false" (click)="generateFile('sdp', null)"><span>Generate</span></button>
                               </td>
                               <td width="30%">Safe Driving Plan</td>
                               <td width="30%">
                                   <a *ngIf="runData?.sdp_file != null" href="{{fileStoragePath}}/sdp/{{runData?.sdp_file}}" target="_blank">{{ runData?.sdp_file}}</a>
                                   <span *ngIf="runData?.sdp_file == null || runData?.sdp_file == ''"><i>No File Available.</i></span>
                               </td>
                               <td width="30%">
                                   <i class="fa fa-spinner fa-spin" *ngIf="sp_sdp"></i>
                                   <span class="text-success font-italic" *ngIf="success_sdp">Successfully generated file.</span>
                                   <span class="text-warning font-italic" *ngIf="failed_sdp">Failed in generating the file.</span>
                               </td>
                           </tr>

                           <!-- MANIFEST FILE -->
                           <tr *ngIf="runData?.run_type_id == 1">
                               <td width="10%" >
                                   &nbsp;&nbsp;<button type="button" class="btn btn-outline-secondary btn-sm mb-1 mr-1" aria-expanded="false" (click)="generateFile('manifest', null)"><span>Generate</span></button>
                               </td>
                               <td width="30%">Manifest</td>
                               <td width="30%">
                                   <a *ngIf="runData?.manifest_file != null" href="{{fileStoragePath}}/manifestfile/{{runData?.manifest_file}}" target="_blank">{{ runData?.manifest_file}}</a>
                                   <span *ngIf="runData?.manifest_file == null || runData?.manifest_file == ''"><i>No File Available.</i></span>
                               </td>
                               <td width="30%">
                                   <i class="fa fa-spinner fa-spin" *ngIf="sp_manifest"></i>
                                   <span class="text-success font-italic" *ngIf="success_manifest">Successfully generated file.</span>
                                   <span class="text-warning font-italic" *ngIf="failed_manifest">Failed in generating the file.</span>
                               </td>
                           </tr>
                       </tbody>
                   </table>
               </div>
           </div>
       </div>
       
   </div>
</ng-template>

<!--  modal for run events -->
<ng-template #run_events let-close="close">
   <div class="modal-header">
       <div class="col px-0">
           <div class="row no-gutters pt-0">
               <div class="col ml-1"><h5 class="modal-title">&nbsp;Actual Manifest Events</h5></div>
           </div>
       </div>
      
       <button type="button" class="close" (click)="close()">
           <span aria-hidden="true">&times;</span>
       </button>
   </div>
   <div class="modal-body">
       <div class="row pt-0">
           <div class="col-md-12">
               
           </div>
       </div>
   </div>
</ng-template>

<!-- START OF MODAL GENERATE RUNSHEET -->
<ng-template #modalRunsheet let-close="close">
   <div class="modal-header">
       <div class="col px-0">
           <div class="row no-gutters pt-0">
               <span class="col-1"><i class="fa fa-2x fa-file-text-o" style="color:orange"></i></span>
               <div class="col ml-1"><h5 class="modal-title">&nbsp;Generate New Runsheet</h5></div>
           </div>
       </div>
      
       <button type="button" class="close" (click)="close()">
           <span aria-hidden="true">&times;</span>
       </button>
   </div>
   <div class="modal-body">
       <div class="row pt-0">
           <div class="col-md-12">
               <p class="mb-0">Are you sure to regenerate new runsheet? This will overwrite the current runsheet.</p> <br />
               <p><i>Note: Kindly download current file before doing so to make your own copy. </i></p>
           </div>
       </div>
   </div>
   <div class="modal-footer"><i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
       <button type="button" class="btn btn-sm btn-success" (click)="generateRunsheet()"  [disabled]="spinner == true" >Generate</button>
       <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
   </div>
</ng-template>
<!-- END OF MODAL RUNSHEET-->

<ng-template #modalActivityInfo>
   <div class="modal-header">
       <h6 class="modal-title">Edit Activity Details</h6>
       <button type="button" class="close" (click)="closeModal()">
           <span aria-hidden="true">&times;</span>
       </button>
   </div>

   <form [formGroup]="activityForm" novalidate>
       <div class="modal-body bg-gray">
           <div class="row">
               <div class="col-12">
                   <div class="form-group">
                       <label>Contact Name:</label>
                       <input type="text" class="form-control" formControlName="contact_name" name="contact_name" />
                   </div>
                   <div class="form-group">
                       <label>Contact #:</label>
                       <input type="number" class="form-control" formControlName="contact_no" name="contact_no" />
                   </div>
                   <div class="form-group">
                       <label>Contact Email:</label>
                       <input type="text" class="form-control" formControlName="contact_email" name="contact_email" />
                   </div>

                   <div class="form-group">
                       <label>Notes:</label>
                       <textarea type="text" class="form-control" formControlName="notes" name="notes"></textarea>
                   </div>
               </div>
           </div>
       </div>  
       
       <div class="modal-footer">
           <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
           <button type="submit" class="btn btn-sm btn-success" [disabled]="spinner == true" (click)="onsubmitActivities(activityForm.value)">Save Changes</button>&nbsp;
           <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">Cancel</button>
       </div>
   </form>
</ng-template>

<!--  modal for deallocate connote func -->
<ng-template #modalDeallocate let-close="close">
    <div class="modal-header">
        <div class="col px-0">
            <div class="row no-gutters pt-0">
                <div class="col ml-1"><h6 class="modal-title">&nbsp;Deallocate Consignments for {{runData.control_no}}</h6></div>
            </div>
        </div>
    </div>
    
    <div class="modal-body">
        <div class="row pt-0">
            <div *ngIf="d_ModalLoader" class="col-md-12 text-center pt-3 pb-3">
                <span><i class="fa fa-spinner fa-spin"></i>&nbsp;Fetching Updated List...</span>       
            </div>
            <div *ngIf="!d_ModalLoader" class="col-md-12"> 
                <ng-container *ngIf="checkListDisplay();else noListTemp">
                    <span style="height: 570px; overflow-y: scroll;">
                        <ng-container *ngFor="let con of connotesList; let i = index">
                            <div class="row p-1">
                                <div class="col-md-1">
                                    <ng-container *ngIf="spinner != true">
                                        <span *ngIf="getConnoteStatus(i) != 'Completed' && getConnoteStatus(i) != 'Ongoing'">
                                            <input  type="checkbox" [(ngModel)]="con.checked">
                                        </span>
                                    </ng-container>
                                </div>
                                <div class="col-md-8"> <!-- connote info -->
                                    <b>{{con.control_no}}</b> {{con.company_name}}<br>
                                    {{getConnoteAddress(i)}} <br>
                                    Reference No: {{con.customer_reference_no}}
                                </div>
    
                                <div class="col-md-3"> <!-- connote status -->
                                    <span *ngIf="getConnoteStatus(i) == 'Completed'" class="text-success">{{getConnoteStatus(i)}}</span>
                                    <span *ngIf="getConnoteStatus(i) != 'Completed'">{{getConnoteStatus(i)}}</span>
                                </div>
                            </div><br>
                        </ng-container>
                    </span>
                </ng-container>

                <ng-template #noListTemp>
                    <div class="col-md-12 text-center pt-3 pb-3">
                        <i>No more connotes left to deallocate.</i>
                    </div>
                </ng-template>
                <div *ngIf="errorMsg1 != ''" class="col-md-12 text-center pl-4 pr-4"> <!-- error messages -->
                    <small class="font-italic" [ngClass]="is_UpdateError == true? 'text-error':'text-success'">{{errorMsg1}}</small> <br>
                    <small *ngIf="is_UpdateWarning" class="text-warning font-italic">{{errorMsg2}}</small> <br>
                </div> 
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="submit" class="btn btn-sm btn-success" [disabled]="spinner == true|| deallocateCheck()" (click)="submitDeallocate()">Deallocate</button>&nbsp;
        <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">Close</button>
    </div>
 </ng-template>



 <!-- START OF ADD/EDIT QAR FORM -->
 <ng-template #modalNCR let-close="close">
        <div class="modal-header">
                <h5 class="modal-title" *ngIf="isEditModeNCR==false">Add New QAR</h5>
                <h5 class="modal-title" *ngIf="isEditModeNCR==true">Edit Quality Assurance Report</h5>
                <button type="button" class="close" (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </button>
        </div>
        <form [formGroup]="NCRForm" (ngSubmit)="onSubmitNCR(NCRForm.value)">
            <div class="modal-body">
                <div class="row pt-0">
                    <div class="form-group col-md-4" >
                        <h6>Breach Category<span class="text-danger">*</span> :</h6>
                        <select  class="form-control form-control-sm" placeholder="Select" formControlName="category_id">
                            <option disabled selected *ngIf="isEditModeNCR==false">Select..</option>
                            <option *ngFor="let br of ncr_categories" value="{{br.id}}">{{br.breach_cat_name}}</option>
                        </select>
                    </div>
   
                    <div class="form-group col-md-4" >
                        <h6>Breach Code<span class="text-danger">*</span> :</h6>
                        <select  class="form-control form-control-sm" placeholder="Select" formControlName="code_id">
                            <option disabled selected *ngIf="isEditModeNCR==false">Select..</option>
                            <option *ngFor="let code of ncr_codes" value="{{code.id}}">{{code.ncr_codename}}</option>
                        </select>
                    </div>

                    <div class="form-group col-md-4" >
                        <h6>Breach Classification<span class="text-danger">*</span> :</h6>                    
                        <select  class="form-control form-control-sm" placeholder="Select" formControlName="classification_id">
                            <option disabled selected *ngIf="isEditModeNCR==false">Select..</option>
                            <option *ngFor="let class of ncr_classification" value="{{class.id}}">{{class.classification_name}}</option>
                        </select>
                    </div>


                    <!-- <div class="form-group col-md-4">
                        <h6>Driver<span class="text-danger">*</span> :</h6>
                        <select  class="form-control form-control-sm" placeholder="Select" formControlName="driver_id">
                            <option disabled selected *ngIf="isEditModeNCR==false">Select..</option>
                            <option *ngFor="let dr of runData?.driver" value="{{dr.driver_id}}">{{dr.first_name}}  {{dr.last_name}}</option>
                        </select>   
                    </div> -->

                    <div class="form-group col-md-4">
                        <h6>Driver<span class="text-danger" *ngIf="NCRForm.value.classification_id == 4">*</span> :</h6>
                        <ss-multiselect-dropdown [options]="pushDriverOptions" [(ngModel)]="pushDriverModel" [ngModelOptions]="{standalone: true}" [texts]="pushDriver" [settings]="pushDriverSettings"></ss-multiselect-dropdown>                        
                        &nbsp;<small *ngIf="!checkDriverModel()" class="text-danger" >Required</small>
                    </div>

                    <div class="form-group col-md-4">
                        <h6>Fleet<span class="text-danger" *ngIf="NCRForm.value.classification_id == 4">*</span> :</h6>
                        <ss-multiselect-dropdown [options]="pushFleetOptions" [(ngModel)]="pushFleetModel" [ngModelOptions]="{standalone: true}" [texts]="pushFleet" [settings]="pushFleetSettings"></ss-multiselect-dropdown>                        
                        &nbsp;<small *ngIf="!checkPushModel()  && NCRForm.value.classification_id == 4" class="text-danger" >Required</small>
                    </div>


                    <div class="form-group col-md-4" >
                        <h6>Manifest Control Number<span class="text-danger" *ngIf="NCRForm.value.classification_id == 4">*</span> :</h6>
                        <input formControlName="run_control_no" class="form-control form-control-sm" type="text" readonly>
                    </div>

                    <div class="col-md-12">
                        <div class="form-group">
                            <h6 for="input-1">Breach Details<span class="text-danger">*</span> :</h6>
                            <textarea class="form-control form-control-sm" formControlName="problem_details" rows="4" cols="50"></textarea>
                        </div>
                    </div>

                    <div class="form-group col-md-4" *ngIf="runData?.customers.length> 0">
                        <h6>Customer </h6>
                        <div class="input-group d-flex align-items-center">
                        <select class="form-control form-control-sm" placeholder="Select" formControlName="customer_id">
                            <option disabled selected *ngIf="isEditModeNCR==false">Select..</option>
                            <option *ngFor="let cust of runData?.customers" value="{{cust.customer_id}}">{{cust.company_name}}</option>
                        </select>
                        <i (click)="resetFormControl('ncr')" ngbTooltip="Clear Customer" class="fa fa-eraser ml-2" aria-hidden="true"></i>
                        </div>
                    </div>


                    <div class="form-group col-md-4">
                        <div class="form-group" *ngIf ="(fileExists==true)">
                            <h6>File:</h6>
                            <label>{{NCRForm.value?.supporting_docs}}</label> <button class="btn btn-sm btn-primary ml-1" type="button" (click)="removeFile(prefixNCR)">Remove File</button>
                        </div>
                        <div class="form-group" *ngIf ="(fileExists==false)">
                            <h6>File :</h6>
                            <app-file-uploader (passFile)="getFile($event, prefixNCR)"></app-file-uploader>
                        </div>
                    </div>

                </div>
            </div>

            <div class="modal-footer">
                <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
                <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
                <button *ngIf="isEditModeNCR==false" type="submit" class="btn btn-sm btn-success" [disabled]="!NCRForm.valid || spinner == true || !isDriverSelected || !is_image || (NCRForm.value.classification_id == 4 && (!checkPushModel() || !NCRForm.value.run_control_no))">Save</button>
                <button *ngIf="isEditModeNCR==true" type="submit" class="btn btn-sm btn-success" [disabled]="!NCRForm.valid || spinner == true || !isDriverSelected || !is_image || (NCRForm.value.classification_id == 4 && (!checkPushModel() || !NCRForm.value.run_control_no))">Save Changes</button>
    
                <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()" [disabled]="spinner == true"  ngbAutofocus >Cancel</button>
            </div>
        </form>
</ng-template>
<!-- END OF MODAL ADD QAR FORM -->

<!--START OF Delete QAR Modal -->
<ng-template #modalDeleteNCR>
    <div class="modal-header">
        <h5 class="modal-title">Delete Quality Assurance Report</h5>
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12">
            Are you sure to delete this Quality Assurance Report ({{objToDelete.control_no}})?
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger" (click)="deleteNCR(objToDelete.id)" [disabled]="spinner == true">Delete</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">Cancel</button>
    </div>
</ng-template> <!--END OF Delete NCR-->

<ng-template #modalDeleteBreachLocation>
    <div class="modal-header">
        <h5 class="modal-title">Delete Breach Location</h5>
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12">
            Are you sure you want to delete this record?
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger" (click)="invalidateBreachRecord(breachId)" [disabled]="spinner == true">Delete</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">Cancel</button>
    </div>
</ng-template> 

<!-- START OF MODAL EDIT THE JOB -->
<ng-template #openModalEditJob let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Update {{runData?.control_no}}
        </h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form [formGroup]="frmJobEditForm" class="form-group">
            <div class="row mb-3">
                <div class="col-md-4">
                    <!-- <div class="d-flex flex-wrap justify-content-between align-items-start"> -->
                        <div class="mb-3"> 
                            Driver:
                            <ss-multiselect-dropdown 
                            [options]="driverSelectOption" 
                            [texts]="driverSelectText" 
                            [settings]="driverSelectSetting"
                            formControlName="drivers"
                            >
                            </ss-multiselect-dropdown>
                        </div>
                        <div class="mb-3"> 
                            Truck:
                            <ss-multiselect-dropdown 
                                [options]="truckSelectOption" 
                                [texts]="truckSelectText" 
                                [settings]="truckSelectSetting"
                                formControlName="truck"
                                >
                            </ss-multiselect-dropdown>
                            <div>
                            </div>
                        </div>
                    <!-- </div> -->
                </div>
                <div class="col-md-8">
                    <div class="formGroup" *ngIf="runData.run_type_id != 1">
                        Route<span class="text-danger">*</span> :
                        <select class="form-control form-control-sm" formControlName="run_route"
                            placeholder="Select">
                            <option selected value='null' disabled>Select..</option>
                            <ng-container *ngFor="let item of this.routes">
                                <option [value]="item.id">{{item.description | titlecase}} {{item.full_route}}</option>
                            </ng-container>
                        </select>
                    </div>   
                </div>
            </div>
            <div class="row"> <!--TODO:: try to make this part scrollable (?)-->
                <div formArrayName="trailers" class="col-12">
                    <div class="mt-2" *ngFor="let phase of allTaskPhases;let i=index">
                        <div class="d-flex flex-wrap justify-content-between align-items-center mb-2">
                            <h6 class="mb-0">PHASE {{i+1}}
                                <ng-container *ngIf="!checkForCompletedTasks(i)">
                                    <a *ngIf="allTaskPhases.length > 1" class="hover text-danger" title="Remove this item" (click)="removeTask(null, null, null, i)">
                                        <span aria-hidden="true">&times;</span>
                                    </a>
                                </ng-container>
                               
                            </h6>
                            <div [formGroupName]="i"> 
                                Trailer:
                                <ss-multiselect-dropdown 
                                [options]="trailerSelectOption" 
                                [texts]="trailerSelectText" 
                                [settings]="trailerSelectSetting"
                                formControlName="trailer"
                                >
                                </ss-multiselect-dropdown>
                            </div>
                        </div>
                        <div dragula="PHASE_TASK" [(dragulaModel)]="allTaskPhases[i]">
                            <div class="card p-3" *ngFor="let task of phase; let num = index">
                                <div class="d-flex flex-wrap justify-content-between align-items-center">
                                    <h6 class="d-flex align-items-center">
                                        <i *ngIf="task.is_done" class="fa fa-check mr-1" aria-hidden="true"></i>
                                        {{task.connote_control_no}}
                                        <span *ngIf="task.run_action_id" class="badge badge-pill mx-1" [ngClass]="actionBadgeDisplay(task.run_action_id)">
                                            {{actionNameDisplay(task.run_action_id)}}
                                        </span>
                                        <!-- <a *ngIf="!task.is_done" class="link-hover text-secondary" title="Edit Task" (click)="editTaskModal(i, num)"><i class="fa fa-fw fa-pencil"></i></a> -->
                                    </h6>  
                                    <a *ngIf="!task.is_done" class="link-hover text-secondary" title="Remove this item" (click)="removeTask(task.id, num, task.run_id, i)">
                                        <small>Remove?</small>
                                    </a>                     
                                </div>
                                <p *ngIf="compareDates(task.start_datetime, task.end_datetime);else elseSameDate" class="d-inline mb-0">
                                    <i class="fa fa-clock-o mr-1" aria-hidden="true"></i>
                                    {{task.start_datetime | date:'d MMM y hh:mm a'}} - {{task.end_datetime | date:'d MMM y hh:mm a'}}
                                </p>
                                <ng-template #elseSameDate>
                                    <p class="d-inline mb-0">
                                        <i class="fa fa-clock-o mr-1" aria-hidden="true"></i>
                                        {{task.start_datetime | date:'d MMM y hh:mm a'}} - {{task.end_datetime | date:'hh:mm a'}}
                                    </p>
                                </ng-template>
    
                                <p *ngIf="task.run_action_id != 12 && locationStringDisplay(task) != '' " class="d-inline mb-0">
                                    <i class="fa fa-map-marker ml-1 mr-1" aria-hidden="true"></i>
                                    {{locationStringDisplay(task)}}
                                </p>
                            </div>
                            <div class="card p-3 align-items-center" *ngIf="phase.length == 0">
                                <small><i>No acitivities in this Phase.</i></small>
                            </div>
                        </div>
                    </div>
                    <small *ngIf="runData.run_type_id == 6 || runData.service_type_id == 10" class="ml-1 mb-4">
                        <a class="hover text-primary" title="Add New Phase" (click)="addPhaseEditForm()"><u>Add New Phase</u></a>   
                    </small>
                </div>
            </div>
        </form>
        <!--ERROR DIV-->
        
        <span class="text-danger"><small><div [innerHTML]="editorCheckRoute()"></div></small></span>
        <span class="text-danger"><small><div [innerHTML]="editorCheckActivities()"></div></small></span>
        <div class="d-flex flex-wrap justify-content-between align-items-start">
            <span class="text-danger"><small>{{editorCheckDriver()}}</small></span>
        </div>
        <div>
            <span class="text-danger"><small>{{editorCheckTruck()}}</small></span>
            <span class="text-danger"><small><div [innerHTML]="editorCheckTrailers()"></div></small></span>
        </div>
    </div>
    <div class="modal-footer">
        <div class="mr-auto">
            <button type="button" class="btn btn-sm btn-info mr-3" (click)="addTaskModal('taskform')" [disabled]="spinner == true">Create New Task</button>
            <button type="button" class="btn btn-sm btn-info"  (click)="addTaskModal('taskpool')"  [disabled]="spinner == true">Create From Task Pool</button>
        </div>
        <div>
            <small class="mr-2">
                <i>*Closing the form will not save your changes.</i>
            </small>
            <button type="button" class="btn btn-sm btn-success" (click)="saveEditChanges()" [disabled]=" !checkEditForm() || spinner == true">
                <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
                Save Changes
            </button>
        </div>
    </div>
 </ng-template>
 <!-- END OF MODAL EDIT THE JOB-->

 <!-- START OF MODAL EDIT ACTIVITY -->
<ng-template #modalAddTask let-close="close">
    <div class="modal-header">
        <div class="col px-0">
            <div class="row no-gutters pt-0">
                <div class="col ml-1"><h5 class="modal-title">
                    {{(jobEditActivityBtn == null)?'Add New Task': 'Update Task'}}
                </h5></div>
            </div>
        </div>
       
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" class="row m-2 p-2">
        <div class="mt-2 mb-2">
            <div class="form-group col-md-12" [formGroup]="frmActivity">
                <div class="row">
                    <!-- Row 1 Form fields -->
                    <div class="col-md-6">
                        <div class="form-group">
                            <h6>Action of Activity<span class="text-danger">*</span> :</h6>
                            <select class="form-control form-control-sm" formControlName="run_action_id"
                                placeholder="Select">
                                <option selected value='' disabled>Select..</option>
                                <ng-container *ngFor="let item of taskActionList()">
                                    <option [value]="item.id">{{item.label | titlecase}}</option>
                                </ng-container>
                            </select>
                        </div>
                        <div class="form-group">
                            <span *ngIf="frmActivity.get('run_action_id').value == 2">
                                <input type="checkbox" formControlName="is_tba" data-toggle="tooltip"
                                title="Check if location is to be determined" placement="top" />
                                    Location is TBA
                            </span>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <h6>Related Connote<span class="text-danger">*</span> :</h6>
                            <app-connote-picker [(connote)]="connote">
                                <input id="connote-id" type="search" class="form-control form-control-sm" appConnoteSearch placeholder="Type in a valid connote control number" aria-describedby="connote-id-help">
                            </app-connote-picker>
                        </div>
                        <div class="form-group">
                            <label for="connote-site-id"><h6>Related Connote Site:</h6></label>
                            <select
                                appConnoteSitePicker
                                id="connote-site-id"
                                class="custom-select"
                                [connote]="connote"
                                formControlName="connote_site_id"
                                aria-describedby="connote-site-id-help"
                                class="form-control form-control-sm">
                            </select>
                        </div>

                    </div>
                    <!-- Row 2 Form fields-->
                    <div class="form-group col-md-12" *ngIf="frmActivity.get('is_tba').value == false">
                            <h6>Location<span class="text-danger">*</span>:</h6>
                            <div class="form-group col-md-12 pl-0 pr-0">
                                <div class="input-group input-group-sm">
                                    <div class="col-md-11 pl-0 pr-0">
                                        <ngx-geo-autocomplete id="auto_location" (componentCallback)="pickupAddressCallback($event)"
                                        [userSettings]="userSettings"></ngx-geo-autocomplete>
                                    </div>
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary btn-sm" type="button" (click)="showLocDetails()">&nbsp;
                                            <ng-container *ngIf="showDetails; else locdropdown">
                                                <i class="fa fa-chevron-up pr-2 pl-2" aria-hidden="true"></i>
                                            </ng-container>
                                            <ng-template #locdropdown>
                                                <i class="fa fa-chevron-down pr-2 pl-2" aria-hidden="true"></i>
                                            </ng-template>
                                            &nbsp;</button>
                                    </div>
                                </div>
                                <div class="address">
                                    <!-- <small class="text-danger" *ngIf="!location_valid"><i>*Location Required.</i><br></small> -->
                                    <small *ngIf="!geometryValue" class="text-danger"><i>Information for the address is incorrect/incomplete, please selected another address.</i></small>
                                </div>
                            </div>
                            <div class="form-group row">
                                <ng-container *ngIf="showDetails">
                                    <div class="form-group col-md-4">
                                        <h6>Street # :</h6>
                                        <input class="form-control form-control-sm" formControlName="street_no" type="text">
                                    </div>
                                    <div class="form-group col-md-8">
                                        <h6>Street :</h6>
                                        <input class="form-control form-control-sm" formControlName="street" type="text">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <h6>Suburb/City<span class="text-danger">*</span> :</h6>
                                        <input class="form-control form-control-sm" formControlName="suburb" type="text">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <h6>State<span class="text-danger">*</span> :</h6>
                                        <input class="form-control form-control-sm" formControlName="state" type="text">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <h6>Postal Code<span class="text-danger">*</span> :</h6>
                                        <input class="form-control form-control-sm" formControlName="postal_code" type="text">
                                    </div>                            
                                </ng-container>
                            </div>

                        </div>
                        <br>
                    <!-- start datetime -->
                    <div class="col-md-3">
                        <div class="form-group">
                            <h6>Start Date & Time<span class="text-danger">*</span> :</h6>
                            <input class="form-control form-control-sm" formControlName="start_date" type="date" (change)="checkDates()">
                            <small class="text-danger" *ngIf="!checkDateTime">*Start date and time should not exceed end date and time!</small>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <ngb-timepicker formControlName="startdate_time"  [meridian]="false" (ngModelChange)="checkDates()"></ngb-timepicker>
                    </div>
                
                    <!-- end datetime -->
                    <div class="col-md-3">
                        <div class="form-group">
                            <h6>End Date & Time<span class="text-danger">*</span> :</h6>
                            <input class="form-control form-control-sm" formControlName="end_date" type="date" (change)="checkDates()">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <ngb-timepicker formControlName="enddate_time"  [meridian]="false" (ngModelChange)="checkDates()"></ngb-timepicker>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer"><i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <small *ngIf="!checkTaskRequirements()" style="color:red">Fill up required fields first!</small>
        <button *ngIf="jobEditActivityBtn == null" type="button" class="btn btn-sm btn-success" [disabled]="(!checkTaskRequirements() || !checkDateTime || !geometryValue)" (click)="createTask(frmActivity.value, 'new')">Save</button>
        <button *ngIf="jobEditActivityBtn !=null" type="button" class="btn btn-sm btn-success" [disabled]="(!checkTaskRequirements() || !checkDateTime || !geometryValue)" (click)="createTask(frmActivity.value, 'update')">Update</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
    </div>
 </ng-template>
 <!-- END OF MODAL EDIT ACTIVITY -->

 <!-- START OF MODAL ADD TASK FROM POOL -->
<ng-template #modalAddTaskFromPool let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Add Run Tasks to the Plan</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <app-run-task-search #taskSelector [selected]="plannedTasks"></app-run-task-search>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-success" *ngIf="taskSelector.selectedChange | async as changes" (click)="modal.close(changes)">Apply Task Selection</button>
        <button type="button" class="btn btn-sm btn-outline-dark" (click)="modal.close(taskSelector.selected)">Cancel</button>
    </div>
 </ng-template>
 <!-- END OF MODAL ADD TASK FROM POOL -->